<template>
<section class="content">
    <div v-if="stepval== 0">
        <div class="text-center">
            <h2 class="mtitle">상품 유형을 선택해 주세요</h2>
        </div>
        <div class="text-center">
            <button type="button" class="btn btn-app" @click="clickgoodsType('MobileCoupon',true,false)">
                <h3>모바일쿠폰</h3>
                <p>
                    모바일쿠폰으로 발행되는
                    <br />상품 입니다.
                </p>
            </button>
            <button type="button" class="btn btn-app" @click="clickgoodsType('BookingCoupon',true,false)">
                <h3>예약필수쿠폰</h3>
                <p>
                    구매 후 예약을해야 사용
                    <br />가능한 상품 입니다.
                </p>
            </button>
            <button type="button" class="btn btn-app" @click="clickgoodsType('Booking',false,false)">
                <h3>예약</h3>
                <p>
                    날짜와 시간을 지정해서
                    <br />사용하는 상품 입니다.
                </p>
            </button>
            <button type="button" class="btn btn-app" @click="clickgoodsType('MoneyCoupon',true,false)">
                <h3>모바일금액권</h3>
                <p>
                    잔액 관리가 가능한
                    <br />상품입니다.
                </p>
            </button>
            <!-- 2021-05-24추가 -->
            <button type="button" class="btn btn-app" @click="clickgoodsType('Combined',false,true)">
                <h3>결합 상품</h3>
                <p>
                    2개 이상의 옵션을<br>
                    결합하는 상품 입니다.
                </p>
            </button>
            <!-- 2023-10-10 추가 -->
            <button type="button" class="btn btn-app" @click="clickgoodsType('PointCoupon',true,false)">
              <h3>포인트권</h3>
              <p>
                플랫폼에서 사용 가능한
                <br />결제수단 입니다.
              </p>
            </button>
        </div>
    </div>
    <div v-if="stepval> 0 && stepval< 6" class="text-center pgheader">
        <div style="display:flex;flex-direction: row;">
            <div class="step">
                <span class="pttop" style="cursor: pointer;" @click="gotoStep(1)">상품정보</span>
                <div class="passline">
                    <div class="linebg"></div>
                    <div :class="['rightline', stepval > 1?'bgpass':'bgfail']"></div>
                    <div class="point_pass" style="cursor: pointer;" @click="gotoStep(1)"></div>
                </div>
            </div>
            <div class="step">
                <span class="ptlbl" style="cursor: pointer;" @click="gotoStep(2)">옵션/가격</span>
                <div class="passline">
                    <div class="linebg"></div>
                    <div :class="['leftline', stepval > 1?'bgpass':'bgfail']"></div>
                    <div :class="['rightline', stepval > 2?'bgpass':'bgfail']"></div>
                    <div :class="stepval > 1?'point_pass':'point_fail'" style="cursor: pointer;" @click="gotoStep(2)"></div>
                </div>
            </div>
            <div class="step">
                <span class="pttop" style="cursor: pointer;" @click="gotoStep(3)">사용조건</span>
                <div class="passline">
                    <div class="linebg"></div>
                    <div :class="['leftline', stepval > 2?'bgpass':'bgfail']"></div>
                    <div :class="['rightline', stepval > 3?'bgpass':'bgfail']"></div>
                    <div :class="stepval > 2?'point_pass':'point_fail'" style="cursor: pointer;" @click="gotoStep(3)"></div>
                </div>
            </div>
            <div class="step" v-if="goodsType != 'Booking'">
                <span class="ptlbl" style="cursor: pointer;" @click="gotoStep(4)">판매채널</span>
                <div class="passline">
                    <div class="linebg"></div>
                    <div :class="['leftline', stepval > 3?'bgpass':'bgfail']"></div>
                    <div :class="['rightline', stepval > 4?'bgpass':'bgfail']"></div>
                    <div :class="stepval > 3?'point_pass':'point_fail'" style="cursor: pointer;" @click="gotoStep(4)"></div>
                </div>
            </div>
            <div class="step">
                <span class="pttop" style="cursor: pointer;" @click="gotoStep(5)">판매정보</span>
                <div class="passline">
                    <div class="linebg"></div>
                    <div :class="['leftline', stepval > 4?'bgpass':'bgfail']"></div>
                    <div :class="stepval > 4?'point_pass':'point_fail'" style="cursor: pointer;" @click="gotoStep(5)"></div>
                </div>
            </div>
        </div>
    </div>
    <div v-if="stepval== 1" class="box box-solid">
        <div class="box-body form-horizontal">
            <div class="form-group">
                <label class="col-sm-2 control-label">상품 유형 *</label>
                <div class="col-sm-10">
                    <label class="control-label">{{ goodsTypeVal(goodsType) }}</label>
                </div>
            </div>
            <div class="form-group" v-if="comTrue && goodsType!='PointCoupon'">
                <label class="col-sm-2 control-label">결합여부</label>
                <div class="col-sm-10">
                    <input type="checkbox" v-model="introduction.forCombined">
                    <label :for="introduction.forCombined">결합등록용 상품입니다. (결합등록용 상품은 외부 사이트에 판매되지 않습니다.)</label>
                </div>
            </div>
            <div class="form-group">
                <label class="col-sm-2 control-label">상품명 *</label>
                <div class="col-sm-10">
                    <input type="text" class="form-control" placeholder="예시) 브랜드명 매장명 메뉴명" v-model="introduction.goodsName" />
                </div>
            </div>
            <div class="form-group" v-if="goodsType != 'PointCoupon' ">
                <label class="col-sm-2 control-label">상품명 태그</label>
                <div class="col-sm-10">
                    <input type="text" class="form-control" placeholder="상품명에 대한 간단한 부연설명으로 하이테이블 매장직원에게만 보여지는 내용입니다. 예시) 아메리카노 서비스로 줄 것" v-model="introduction.goodsTag" />
                </div>
            </div>
            <div class="form-group">
                <label class="col-sm-2 control-label">상품 소개</label>
                <div class="col-sm-10">
                    <input type="text" class="form-control" placeholder="예시) 신제품 소개, 온라인 이용 시 혜택 등" v-model="introduction.intro" />
                </div>
            </div>
            <div class="form-group">
                <label class="col-sm-2 control-label">대표 이미지 *</label>
                <div class="col-sm-10 displayIn">
                    <SingleThumbnail v-if="introduction.mainImage != null" v-model="introduction.mainImage.url" :imgtype="imgtype.GOODS" :change="onMainImage" :imgFile="imgFile" />
                    <div class="left-store-btn">
                        <button class="btn btn-default" @click="storeimage()">매장 이미지에서 선택</button>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <label class="col-sm-2 control-label">추가 이미지 *</label>
                <div class="col-sm-10">
                    <button type="button" class="btn btn-default" @click="showNewSubImage">등록</button>
                </div>
            </div>
            <div class="form-group text-center">
                <ProdAddImg v-for="(simg, sidx) in introduction.subImages" :key="sidx" :title="simg.title" :imgdes="simg.description" :images="simg.images" @editProd="showEditSubImage(simg, sidx)" @remove="emvsubimg(sidx)" @sortdown="sortdownsub(sidx)" @sortup="sortupsub(sidx)" @sortTopsub="sortTopsub(sidx)" @sortlowestsub="sortlowestsub(sidx)"/>
            </div>
        </div>
        <div class="box-footer text-center">
            <button type="button" class="btn btn-default" @click="baseinfcheck">다음</button>
        </div>
    </div>
    <div v-if="stepval== 2" class="box box-solid">
        <div class="box-body form-horizontal" >
            <div class="form-group" v-if="!comTrue2 && goodsType != 'PointCoupon'">
                <label class="col-sm-2 control-label">입금가 설정 *</label>
                <div class="col-sm-10 radio">
                    <label>
                        <input type="radio" :value="false" v-model="goodsOption.hasOwnDeliveryPrice" />매장별 수수료 적용
                    </label>
                    <label>
                        <input type="radio" :value="true" v-model="goodsOption.hasOwnDeliveryPrice" />상품별 수수료 적용
                    </label>
                </div>
            </div>
            <div v-if="!comTrue2">
                <div class="form-group" v-if="!isMobile(goodsType)">
                    <label class="col-sm-2 control-label">적용 요일 *</label>
                    <div class="col-sm-10" style="display:inline-flex;flex-wrap: wrap;">
                        <div class="radio">
                            <label>
                                <input type="radio" value="Everyday" v-model="usableHour.dayOfWeekType" />매일
                            </label>
                            <label>
                                <input type="radio" value="Weekday" v-model="usableHour.dayOfWeekType" />주중
                            </label>
                            <label>
                                <input type="radio" value="Weekend" v-model="usableHour.dayOfWeekType" />주말
                            </label>
                            <label>
                                <input type="radio" value="Custom" v-model="usableHour.dayOfWeekType" />사용자 지정
                            </label>
                        </div>
                        <div class="btn-group weeksel" v-if="usableHour.dayOfWeekType == 'Custom'">
                            <button type="button" :class="['btn', 'btn-sm', 'btn-default', usableHour.monday && 'btn-selweek']" @click="onmonday">월
                            </button>
                            <button type="button" :class="['btn', 'btn-sm', 'btn-default', usableHour.tuesday && 'btn-selweek']" @click="ontuesday">화
                            </button>
                            <button type="button" :class="['btn', 'btn-sm', 'btn-default', usableHour.wednesday && 'btn-selweek']" @click="onwednesday">수
                            </button>
                            <button type="button" :class="['btn', 'btn-sm', 'btn-default', usableHour.thursday && 'btn-selweek']" @click="onthursday">목
                            </button>
                            <button type="button" :class="['btn', 'btn-sm', 'btn-default', usableHour.friday && 'btn-selweek']" @click="onfriday">금
                            </button>
                            <button type="button" :class="['btn', 'btn-sm', 'btn-default', usableHour.saturday && 'btn-selweek']" @click="onsaturday">토
                            </button>
                            <button type="button" :class="['btn', 'btn-sm', 'btn-default', usableHour.sunday && 'btn-selweek']" @click="onsunday">일
                            </button>
                        </div>
                    </div>
                </div>
                <div class="form-group" v-if="!isMobile(goodsType)">
                    <label class="col-sm-2 control-label">적용 시간 *</label>
                    <div class="col-sm-10">
                        <div class="input-group">
                            <select class="form-control" style="width: auto; margin-right:10px" v-model="addhours">
                                <option v-for="n in 24" :key="n" :value="n-1">{{ n - 1 }}시</option>
                            </select>
                            <select class="form-control" style="width: auto; margin-right:10px" v-model="addminutes">
                                <option v-for="n in 60" :key="n" :value="n-1">{{ n - 1 }}분</option>
                            </select>
                            <button type="button" class="btn btn-default" @click="addUsableHour">추가</button>
                        </div>
                        <div class="input-group" style="display:inline-flex;flex-wrap: wrap;">
                            <MarkLbl v-for="(hitem, hidx) in usableHour.hours" :key="hidx" :label="getHourFormat(hitem)" :index="hidx" :close="rmvhours" />
                        </div>
                    </div>
                </div>
                <div class="form-group" v-if="!isMobile(goodsType)">
                    <label class="col-sm-2 control-label">예약불가일</label>
                    <div class="col-sm-10">
                        <div class="input-group" style="display: inline-flex; flex-wrap: wrap">
                            <DatePicker v-model="unusableDate" style="margin-right:10px" />
                            <button type="button" class="btn btn-default" @click="addUnusableDay">추가</button>
                        </div><br>
                        <div class="input-group" style="display: inline-flex; flex-wrap: wrap">
                            <MarkLbl v-for="(hitem, hidx) in usableHour.unusableDays" :key="hidx" :label="getUnusableDayFormat(hitem)" :index="hidx" :close="rmvUnusableDays" />
                        </div>
                    </div>
                </div>
            </div>
            <!-- 20210525추가 -->
            <div class="modal" :style="showmodal && {'display': 'block'}">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header border-bottom-0">
                            <h3>상품검색</h3>
                        </div>
                        <div class="box-body">
                            <div style="display:inline-flex;flex-wrap: wrap;width: 100%;align-items: center;">
                                <select class="form-control" v-model="keywordType" style="width:auto;margin-right:10px" @change="refreshPage2">
                                    <option value="NoKeyword"></option>
                                    <option value="GoodsId">상품코드</option>
                                    <option value="GoodsNameContaining">상품명</option>
                                </select>
                                <div class="input-group" style="flex:1;max-width:400px;min-width:100px">
                                    <input type="text" class="form-control" style="flex:1" v-model="keyword" @change="refreshPage2" />
                                    <span class="input-group-btn">
                                        <button type="button" class="btn btn-default" @click="refreshPage2">검색</button>
                                    </span>
                                </div>
                            </div>
                            <div>
                                <table class="table table-hover text-nowrap">
                                    <thead>
                                        <tr>
                                            <th>상품코드</th>
                                            <th>상품명</th>
                                            <th>옵션코드</th>
                                            <th>옵션명</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody v-for="(combined, index3) in content" v-bind:key="combined.goodsId">
                                        <tr v-for="(combined2, index2) in combined.options" :key="index2">
                                            <td v-if="index2 === 0" :rowspan="combined.options.length"> {{combined.goodsId}}</td>
                                            <td v-if="index2 === 0" :rowspan="combined.options.length"> {{combined.goodsName}}</td>
                                            <td>
                                                {{ combined.options[index2].optionId }}
                                            </td>
                                            <td>
                                                {{ combined.options[index2].optionName }}
                                            </td>
                                            <td>
                                                <button @click="combinedChild(index3,index2,combined.goodsType)">추가</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="modal-footer" style="text-align:center !important">
                            <button type="button" class="btn btn-default" @click="closemodal">닫기</button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- e 20210525추가 -->
            <div class="form-group">
                <label class="col-sm-2 control-label">옵션/가격 등록 *
                </label>
                <div class="col-sm-10">
                    <div class="input-group" style="width:100%">
                        <button type="button" class="btn btn-sm btn-default pull-right" @click="addOption">옵션추가</button>
                    </div>
                    <div class="table-responsive p-0">
                        <table class="table table-hover text-nowrap text-center">
                            <thead>
                                <tr>
                                    <th>대표옵션</th>
                                    <th>옵션명</th>
                                    <th>정상가</th>
                                    <th>판매가</th>
                                    <th v-if="goodsOption.hasOwnDeliveryPrice">입금가</th>
                                    <th>재고수량</th>
                                    <th v-if="!isMobile(goodsType) && goodsType !== 'Combined'">권종</th>
                                    <th v-if="!isMobile(goodsType) && goodsType !== 'Combined'">인원</th>
                                    <th v-if="goodsType == 'Combined'">상품검색</th>
                                    <th>삭제</th>
                                    <th>순서</th>
                                </tr>
                            </thead>
                            <tbody v-for="(oitem, idx) in goodsOption.options" :key="idx">
                                <tr>
                                    <td>
                                        <label class="control-label">
                                            <input type="radio" :value="true" :checked="oitem.mainOption" @click="onmainOption(idx)" />
                                        </label>
                                    </td>
                                    <td>
                                        <input type="text" class="form-control" style="min-width:200px" v-model="oitem.optionName" />
                                    </td>
                                    <td>
                                        <input type="number" :disabled="goodsType == 'Combined'" class="form-control" style="min-width:80px" :value="calculatedListPrice(idx,'listprice')" v-if="goodsType == 'Combined'" />
                                        <input type="number" class="form-control" style="min-width:80px" v-model="oitem.listPrice" v-else />
                                    </td>
                                    <td>
                                        <input ref="" type="number" :disabled="goodsType == 'Combined'" class="form-control" style="min-width:80px" ref:="salePriceInput" :value="calculatedListPrice(idx,'salePrice')" v-if="goodsType == 'Combined'" />
                                        <input type="number" :disabled="goodsType == 'Combined'" class="form-control" style="min-width:80px" v-model="oitem.salePrice" v-else />
                                        <label>{{ percent(oitem.listPrice - oitem.salePrice, oitem.listPrice) }}</label>
                                    </td>
                                    <td v-if="goodsOption.hasOwnDeliveryPrice">
                                        <input type="number" class="form-control" style="min-width:80px" v-model="oitem.deliveryPrice" />
                                        <label>{{ percent(oitem.salePrice - oitem.deliveryPrice, oitem.salePrice) }}</label>
                                    </td>
                                    <td>
                                        <input type="number" class="form-control" :disabled="goodsType == 'Combined'" max="99999" style="min-width:80px" :value="calculatedListPrice(idx,'inventory')" v-if="goodsType == 'Combined'" />
                                        <input type="number" class="form-control" :disabled="goodsType == 'Combined'" max="99999" style="min-width:80px" v-else v-model="oitem.inventory" />
                                    </td>
                                    <td v-if="!isMobile(goodsType) && goodsType !== 'Combined'">
                                        <label class="control-label" style="display:block;text-align: left;">
                                            <input type="radio" value="Adult" v-model="oitem.ageGroup" />성인
                                        </label>
                                        <label class="control-label" style="display:block;text-align: left;">
                                            <input type="radio" value="Child" v-model="oitem.ageGroup" />어린이
                                        </label>
                                        <label class="control-label" style="display:block;text-align: left;">
                                            <input type="radio" value="Baby" v-model="oitem.ageGroup" />유아
                                        </label>
                                    </td>
                                    <td v-if="!isMobile(goodsType) && goodsType !== 'Combined'">
                                        <div class="input-group">
                                            <input type="number" class="form-control" max="99999" min="1" style="max-width:80px;" v-model="oitem.headcount" />
                                            <h5>명</h5>
                                        </div>
                                    </td>
                                    <td v-if="goodsType == 'Combined'">
                                        <button @click="onClickSearch(idx)">상품검색</button>
                                    </td>
                                    <td>
                                        <button type="button" class="btn btn-social-icon" @click="rmvoption(idx)">
                                            <i class="fa fa-fw fa-trash-o"></i>
                                        </button>
                                    </td>
                                    <td>
                                        <drop @drop="optionsort(idx, $event)">
                                            <drag class="btn btn-default btn-social-icon" :transfer-data="{index:idx, mark:'option'}">
                                                <i class="fa fa-fw fa-arrows-v"></i>
                                            </drag>
                                        </drop>
                                    </td>
                                </tr>
                                <!-- {{ oitem.childOptions }} -->
                                <tr v-for="(combinedChild, idx2) in oitem.childOptionIds" :key="idx2">
                                    <td>
                                        {{ combinedChild.optionId }}
                                    </td>
                                    <td>
                                        {{ combinedChild.goodsName}} {{ combinedChild.optionName }}
                                    </td>
                                    <td>
                                        {{ combinedChild.listPrice }}
                                    </td>
                                    <td>
                                        {{ combinedChild.salePrice }}
                                    </td>
                                    <td>
                                        {{ combinedChild.inventory }}
                                    </td>
                                    <td>
                                        <button type="button" class="btn btn-social-icon" @click="rmvsubOption(idx,idx2)">
                                            <i class="fa fa-fw fa-trash-o"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="box-footer text-center">
            <button type="button" class="btn btn-default" @click="gotoStep_1(comTrue,comTrue2)" style="margin-right:10px">이전</button>
            <button type="button" class="btn btn-default" @click="checkOptionPrice">다음</button>
        </div>
    </div>
    <div v-if="stepval== 3" class="box box-solid">
        <div class="box-body form-horizontal">
            <UseStore
                      :noShowLabel="false"
                      @brandkeyUpdatechilde="brandkeyUpdate"
                      @brandstoresUpdatechilde="brandstoresUpdate"
                      @tmselstoreschild="tmselstoresUpdate"
                      @tselstoreschilde="tselstoresUpdate"
                      :brandkey="brandkey"
                      :goodsType="goodsType"
                      :tmselstores="tmselstores"
                      :serviceCondition="serviceCondition"
                      :brandstores="brandstores"
                      :tselstores="tselstores"
            />
            <div class="form-group">
                <label class="col-sm-2 control-label">판매기간 *</label>
                <div class="col-sm-10" style="display:inline-flex;flex-wrap: wrap;">
                    <div class="radio">
                        <label>
                            <input type="radio" :value="false" v-model="serviceCondition.timeCondition.hasSalesPeriod" />제한없음
                        </label>
                        <label>
                            <input type="radio" :value="true" v-model="serviceCondition.timeCondition.hasSalesPeriod" />제한있음
                        </label>
                    </div>
                    <div class="input-group" v-if="serviceCondition.timeCondition.hasSalesPeriod" style="display: inline-flex;flex-wrap: wrap;">
                        <DatePicker v-model="serviceCondition.timeCondition.saleStartDate" :last="serviceCondition.timeCondition.saleEndDate" />
                        <span class="input-group-addon" style="border:none;display:inline-flex">-</span>
                        <DatePicker v-model="serviceCondition.timeCondition.saleEndDate" :first="serviceCondition.timeCondition.saleStartDate" />
                    </div>
                </div>
            </div>
            <div class="form-group" v-if="!isBooking(goodsType) && !comTrue2">
                <label class="col-sm-2 control-label">유효기간 *</label>
                <div class="col-sm-10">
                    <div class="radio">
                        <label>
                            <input type="radio" value="SetDayCount" v-model="serviceCondition.timeCondition.availableDateSetting" />구매후
                        </label>
                        <div class="input-group" style="display:inline-flex;margin-left:20px" v-if="serviceCondition.timeCondition.availableDateSetting == 'SetDayCount'">
                            <input type="number" class="form-control" v-model="serviceCondition.timeCondition.availableDayCount" @input="inputableDayCount" @change="inputableDayCount" />
                            <h5>일</h5>
                        </div>
                    </div>
                    <div class="form-group" style="margin:0px;margin-top:10px;display:inline-flex;flex-wrap: wrap;">
                        <div class="radio">
                            <label>
                                <input type="radio" value="SetFromToDate" v-model="serviceCondition.timeCondition.availableDateSetting" />기간 지정
                            </label>
                        </div>
                        <div style="display: inline-flex;flex-wrap: wrap;" v-if="serviceCondition.timeCondition.availableDateSetting == 'SetFromToDate'">
                            <DatePicker v-model="serviceCondition.timeCondition.availableFromDate" :last="serviceCondition.timeCondition.availableToDate" />
                            <span class="input-group-addon" style="border:none;display:inline-flex">-</span>
                            <DatePicker v-model="serviceCondition.timeCondition.availableToDate" :first="serviceCondition.timeCondition.availableFromDate" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group" v-if="!isBooking(goodsType) && !introduction.forCombined">
                <label class="col-sm-2 control-label">취소기한 *</label>
                <div class="col-sm-10">
                    <div class="radio">
                      <label>
                        <input type="radio" value="SetDayCount" v-model="serviceCondition.timeCondition.cancellableDateSetting"/>구매후
                      </label>
                      <div class="input-group" style="display: inline-flex; flex-wrap: wrap;"
                           v-if="serviceCondition.timeCondition.cancellableDateSetting == 'SetDayCount'">
                        <label class="margin-r-5">
                            <input type="radio" :value="0" v-model="serviceCondition.timeCondition.itemCancellableDayCount" />취소불가
                        </label>
                        <label class="margin-r-5">
                            <input type="radio" :value="7" v-model="serviceCondition.timeCondition.itemCancellableDayCount" />취소가능
                            [7일]
                        </label>
                        <label class="margin-r-5">
                            <input type="radio" :value="90" v-model="serviceCondition.timeCondition.itemCancellableDayCount" />취소가능
                            [90일]
                        </label>
                        <label class="margin-r-5">
                            <input type="radio" :value="100" :checked="(serviceCondition.timeCondition.itemCancellableDayCount != 0) && (serviceCondition.timeCondition.itemCancellableDayCount != 7) && (serviceCondition.timeCondition.itemCancellableDayCount != 90)" @click="onCancellableDayCount" />취소가능 [기타]
                        </label>
                    <div class="input-group" style="display:inline-flex; margin-top: -8px; padding-left: 4px;" v-if="(serviceCondition.timeCondition.itemCancellableDayCount != 0) && (serviceCondition.timeCondition.itemCancellableDayCount != 7) && (serviceCondition.timeCondition.itemCancellableDayCount != 90)">
                        <input type="number" class="form-control" v-model="serviceCondition.timeCondition.itemCancellableDayCount" />
                        <h5>일</h5>
                    </div>
                </div>
            </div>
          <div class="form-group"
               style="margin: 0px;margin-top: 10px;display: flex;flex-direction: row;flex-wrap: wrap;">
            <div class="radio">
              <label>
                <input type="radio" value="SetFromToDate"
                       v-model="serviceCondition.timeCondition.cancellableDateSetting"/>기간 지정
              </label>
            </div>
            <div style="display: inline-flex; flex-wrap: wrap"
                 v-if="serviceCondition.timeCondition.cancellableDateSetting == 'SetFromToDate'">

              <DatePicker v-model="serviceCondition.timeCondition.cancellableToDate"/>
            </div>
          </div>
        </div>
    </div>
          <!--useStore TF 로 백엔드로 넘기면됨 -->
            <div class="form-group" v-if="goodsType == 'PointCoupon' ">
              <label class="col-sm-2 control-label">사용매장 *</label>
              <div class="col-sm-10" style="display:inline-flex;flex-wrap: wrap;">
                <div class="radio">
                  <label>
                    <input type="radio" :value="false" v-model="useStoreToggle" />제한없음
                  </label>
                  <label>
                    <input type="radio" :value="true" v-model="useStoreToggle" />매장선택
                  </label>
                </div>
              </div>
            </div>
<!--          여기-->
            <PointCouponUserStore v-if="goodsType == 'PointCoupon' && useStoreToggle == true "
                      :noShowLabel="true"
                      @pointbrandkeyUpdatechilde="pointCouponbrandkeyUpdate"
                      @pointbrandstoresUpdatechilde="pointCouponbrandstoresUpdate"
                      @pointtmselstoreschild="pointCoupontmselstoresUpdate"
                      @pointtselstoreschilde="pointCoupontselstoresUpdate"
                      :brandkey="pointCouponbrandkey"
                      :goodsType="goodsType"
                      :tmselstores="pointCoupontmselstores"
                      :serviceCondition="pointCouponserviceCondition"
                      :brandstores="pointCouponbrandstores"
                      :tselstores="pointCoupontselstores" />
        </div>
        <div class="box-footer text-center">
            <button type="button" class="btn btn-default" @click="gotoStep_2" style="margin-right:10px">이전</button>
            <button type="button" class="btn btn-default" @click="usecondition_Next">다음</button>
        </div>
    </div>
    <div v-if="stepval== 4" class="box box-solid">
        <div class="box-body form-horizontal">
            <div class="form-group">
                <label class="col-sm-2 control-label">판매채널 *</label>
                <div class="col-sm-10">
                    <div class="radio">
                        <label>
                            <input type="radio" :value="true" v-model="b2bChannel.channelSalesAgreement" />외부채널 배포 동의
                        </label>
                        <label>
                            <input type="radio" :value="false" v-model="b2bChannel.channelSalesAgreement" />외부채널 배포 동의 안함
                        </label>
                    </div>
                    <div class="input-group checkbox" style="display: inline-flex;flex-wrap: wrap;" v-if="b2bChannel.channelSalesAgreement">
                        <label v-for="(chitem, chidx) in channels" :key="chidx">
                            <input name="isii" type="checkbox" :value="chitem.channelCode" :checked="isAgreeChannel(chitem.channelCode)" @change="onchangechannel(chitem.channelCode, $event)" />{{ chitem.channelName }}
                        </label>
                    </div>
                    <label v-if="b2bChannel.channelSalesAgreement" style="display:block;margin-top:10px;">※ 신규 채널 추가 오픈 시 해당 채널
                        배포는 동의한 것으로 간주됩니다.</label>
                </div>
            </div>
        </div>
        <div class="box-body form-horizontal">
            <div class="form-group">
                <label class="col-sm-2 control-label">테이블엔조이 배포여부</label>
                <div class="col-sm-10">
                    <div class="radio">
                        <label>
                            <input type="radio" :value="false" v-model="b2bChannel.tablenjoyExcluded" />테이블엔조이 배포 동의
                        </label>
                        <label>
                            <input type="radio" :value="true" v-model="b2bChannel.tablenjoyExcluded" />테이블엔조이 배포 동의 안함
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <div class="box-footer text-center">
            <button type="button" class="btn btn-default" @click="gotoStep_3" style="margin-right:10px">이전</button>
            <button type="button" class="btn btn-default" @click="gotoStep_5">다음</button>
        </div>
    </div>
    <div v-if="stepval== 5" class="box box-solid">
        <div class="box-header">
            <h3 class="box-title">판매정보</h3>
        </div>
        <div class="box-body form-horizontal">
            <div class="form-group" style="margin:0px">
                <label>※ 아래 입력 정보는 저장되지 않으며, 판매정보 자동 생성에만 사용됩니다.</label>
            </div>
            <div class="form-group">
                <label class="col-sm-2 control-label">상품유형</label>
                <div class="col-sm-10">
                    <label class="control-label" style="margin-right:20px">{{ goodsTypeVal(goodsType) }}</label>
                </div>
            </div>
            <div class="form-group" v-if="!comTrue2">
                <label class="col-sm-2 control-label">유효기간 (사용조건)</label>
                <div class="col-sm-10">
                    <h5 v-if="serviceCondition.timeCondition.availableDateSetting == 'SetDayCount'">
                        구매 후 {{ serviceCondition.timeCondition.availableDayCount }}일
                        <!-- <i class="fa fa-fw fa-arrows-h"></i> -->
                    </h5>
                    <h5 v-if="serviceCondition.timeCondition.availableDateSetting == 'SetFromToDate'">
                        {{ serviceCondition.timeCondition.availableFromDate }} ~
                        {{ serviceCondition.timeCondition.availableToDate }}
                    </h5>
                </div>
            </div>
            <div class="form-group">
                <label class="col-sm-2 control-label">취소기한 (사용조건)</label>
                <div class="col-sm-10">
                    <h5 v-if="serviceCondition.timeCondition.itemCancellableDayCount == 0">
                        취소불가
                    </h5>
                    <h5 v-if="serviceCondition.timeCondition.itemCancellableDayCount > 0">
                        취소가능 {{ serviceCondition.timeCondition.itemCancellableDayCount }}일
                    </h5>
                </div>
            </div>
            <div class="form-group" v-if="goodsType != 'PointCoupon' ">
                <label class="col-sm-2 control-label">최대 이용매수</label>
                <div class="col-sm-10" style="display:inline-flex;flex-wrap: wrap;">
                    <div class="radio">
                        <label>
                            <input type="radio" :value="false" v-model="maxuselimit" />제한없음
                        </label>
                        <label>
                            <input type="radio" :value="true" v-model="maxuselimit" />최대
                        </label>
                    </div>
                    <div class="input-group" style="display:inline-flex;" v-if="maxuselimit">
                        <input type="number" class="form-control" v-model="maxusecount" />
                    </div>
                    <h5>매 사용 가능</h5>
                </div>
            </div>
            <div class="form-group" v-if="goodsType != 'Booking' && goodsType != 'PointCoupon' ">
                <label class="col-sm-2 control-label">사전예약필수</label>
                <div class="col-sm-10" style="display:inline-flex;flex-wrap: wrap;">
                    <div class="radio">
                        <label>
                            <input type="radio" :value="false" v-model="mindaylimit" />필수아님
                        </label>
                        <label>
                            <input type="radio" :value="true" v-model="mindaylimit" />최소
                        </label>
                    </div>
                    <div class="input-group" style="display:inline-flex;" v-if="mindaylimit">
                        <input type="number" class="form-control" v-model="minreservday" />
                    </div>
                    <h5>일 전 까지 사전예약 필수</h5>
                </div>
            </div>
            <div class="form-group" v-if="goodsType != 'PointCoupon' ">
                <label class="col-sm-2 control-label">소인기준</label>
                <div class="col-sm-10" style="display:inline-flex;flex-wrap: wrap;">
                    <div class="radio">
                        <label>
                            <input type="radio" :value="false" v-model="showagegroup" />비노출
                        </label>
                        <label>
                            <input type="radio" :value="true" v-model="showagegroup" />노출
                        </label>
                    </div>
                    <div v-if="showagegroup" class="input-group" style="display:inline-flex;">
                        <input type="number" class="form-control" v-model="minage" />
                    </div>
                    <h5 v-if="showagegroup" style="margin-right:20px;">세 ~</h5>
                    <div v-if="showagegroup" class="input-group" style="display:inline-flex;">
                        <input type="number" class="form-control" v-model="maxage" />
                    </div>
                    <h5 v-if="showagegroup">세</h5>
                </div>
            </div>
            <div class="form-group" v-if="goodsType != 'PointCoupon' ">
                <label class="col-sm-2 control-label">주차안내</label>
                <div class="col-sm-10" style="display:inline-flex;flex-wrap: wrap;">
                    <div class="radio">
                        <label>
                            <input type="radio" :value="false" v-model="parkmenu" />주차불가
                        </label>
                        <label>
                            <input type="radio" :value="true" v-model="parkmenu" />주차가능
                        </label>
                    </div>
                    <div v-if="parkmenu" class="input-group" style="flex:1">
                        <input type="text" class="form-control" v-model="parkaddress" />
                    </div>
                </div>
            </div>
            <div class="form-group" v-if="goodsType != 'PointCoupon' ">
                <label class="col-sm-2 control-label">운영시간</label>
                <div class="col-sm-10" style="display:inline-flex;flex-wrap: wrap;">
                    <div class="radio">
                        <label>
                            <input type="radio" :value="false" v-model="opentime" />비노출
                        </label>
                        <label>
                            <input type="radio" :value="true" v-model="opentime" />노출
                        </label>
                    </div>
                    <div v-if="opentime" class="input-group" style="flex:1">
                        <input type="text" class="form-control" v-model="openvalue" />
                    </div>
                </div>
            </div>
            <!-- 20210527추가 -->
            <div class="form-group" v-if="comTrue2">
                <label class="col-sm-2 control-label">상품유형</label>
                <div class="col-sm-10" style="display:inline-flex;flex-wrap: wrap;">
                    <div class="radio">
                        <label>
                            <input type="radio" class="goodsTypesL" value="mobileCoupons" v-model="goodsTypesL" />모바일쿠폰
                        </label>
                        <label>
                            <input type="radio" class="goodsTypesL" value="moneyCoupons" v-model="goodsTypesL" />모바일금액권
                        </label>
                        <label>
                            <input type="radio" class="goodsTypesL" value="BookingCoupon" v-model="goodsTypesL" />예약필수쿠폰
                        </label>
                    </div>
                </div>
            </div>
            <!-- 20210527추가 -->
            <div class="form-group text-center">
                <button type="button" class="btn btn-default" @click="showAutoGen">판매정보 자동 생성</button>
            </div>
            <h4>사용정보 *</h4>
            <div class="form-group" style="margin:0px">
                <textarea class="form-control" v-model="usage.useInfo" rows="8"></textarea>
            </div>
            <h4>기본정보 *</h4>
            <div class="form-group" style="margin:0px">
                <textarea class="form-control" v-model="usage.baseInfo" rows="8"></textarea>
            </div>
            <h4>유의사항 *</h4>
            <div class="form-group" style="margin:0px">
                <textarea class="form-control" v-model="usage.notes" rows="8"></textarea>
            </div>
            <h4>취소/환불 규정 *</h4>
            <div class="form-group" style="margin:0px">
                <textarea class="form-control" v-model="usage.returnsAndRefunds" rows="8"></textarea>
            </div>
        </div>
        <div class="box-footer text-center">
            <button v-if="goodsType != 'Booking'" type="button" class="btn btn-default" @click="gotoStep_4" style="margin-right:10px">이전
            </button>
            <button v-if="goodsType == 'Booking'" type="button" class="btn btn-default" @click="gotoStep_3" style="margin-right:10px">이전
            </button>
            <button type="button" class="btn btn-default" @click="showRegConfirm">등록하기</button>
        </div>
    </div>
    <div v-if="stepval== 6">
        <div class="text-center">
            <h3>상품 등록이 완료되었습니다.</h3>
            <h4>상품 검수 승인 이후 판매가 시작됩니다.</h4>
            <button type="button" class="btn btn-default" @click="newRegInfo" style="margin-right:10px">추가등록</button>
            <button type="button" class="btn btn-default" @click="goReqinspec">검수신청내역보기</button>
        </div>
    </div>
    <div class="modal" :style="addimgdlg && {'display': 'block'}">
        <div class="modal-dialog drag">
            <div class="modal-content">
                <div class="modal-header border-bottom-0">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeAddImage">
                        <span aria-hidden="true">×</span>
                    </button>
                    추가 이미지
                </div>
                <div v-show="showDragImg2">
                    <div class="modal-body addmodals">
                        <div :class="[addStoreImgUse ? 'addimgInputGroup':'addimgInputGroup wid100']">
                            <div class="form-group">
                                <label class="control-label">제목</label>
                                <input type="text" class="form-control" v-model="addsubimg.title" />
                            </div>
                            <div class="form-group">
                                <label class="control-label">설명</label>
                                <input type="text" class="form-control" v-model="addsubimg.description" />
                            </div>
                            <div class="form-group">
                                <label class="control-label flexDiv">
                                    <span>이미지 추가 최대 3개</span>
                                    <span class="lfetImgTitle">
                                        <input type="checkbox" v-model="addStoreImgUse">
                                        <label :for="addStoreImgUse">매장 이미지 사용</label>
                                    </span>
                                </label>
                                <div class="addlist" style="width:100%">
                                    <StoreProdImg :value="addsubimg.images"  :index="addsubimg.images.length" style="margin-right:10px" @getsubFileData="getsubFileData" @newimgadd="onAddsubImg" :change="onRmvSubImg" ref="subImages" />
                                </div>
                            </div>
                        </div>

                        <div class="imgBoxDivGroup" v-if="addStoreImgUse">
                            <div class="imgDragbox" style="background: #dedede;">
                                <div class="imgDragbox-div">
                                    <select class="form-control imgdragselect" v-model="imgdragselect" @change="storeImgList">
                                        <option v-for="(store,idx) in storeList" :key="idx" :value="store.storeCode" :selected="imgdragselect">{{ store.name }}</option>
                                    </select>
                                    <button @click="usestoreedit('add')" type="button" class="btn btn-default">이용 가능 매장 수정</button>
                                </div>
                                <ul class="titleArr">
                                    <li class="cls_click" v-for="(titem,idx) in titleArr" :key="idx" @click="titleArrClcik(titem)">
                                        <a>{{titem.title}}</a>
                                    </li>
                                </ul>
                                <div>
                                    <ul class="tab">
                                        <li v-for="title in storeTitleList" :key="title">{{ title }}</li>
                                    </ul>
                                </div>
                                <div :id="'holder' + addsubimg.images.length" class="dropImgBox" v-on:dragover="allowDrop" v-on:drop="ondrop($event,1)" @dragenter="onDragenter">
                                    <img v-for="(img,idx) in imgDragList" :key="idx" class="imgboxChild" :src="img.url" :width="img.width" :height="img.height" draggable="true" v-on:dragstart="drag" :id="'imgidx'+idx">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button v-if="editsubimgidx < 0" type="button" class="btn btn-default" @click="onAddsubImages">추가</button>
                        <button v-if="editsubimgidx > -1" type="button" class="btn btn-default" @click="onMdfsubImages">저장</button>
                    </div>
                </div>
                <div style="height:400px" v-show="!showDragImg2">
                    <UseStore :noShowLabel="true" @brandkeyUpdatechilde="brandkeyUpdate" @brandstoresUpdatechilde="brandstoresUpdate" @tmselstoreschild="tmselstoresUpdate" @tselstoreschilde="tselstoresUpdate" :brandkey="brandkey" :goodsType="goodsType" :tmselstores="tmselstores" :serviceCondition="serviceCondition" :brandstores="brandstores" :tselstores="tselstores" />
                    <div class="text-center mt-2">
                        <button @click="storeAddSelect('add')" type="button" class="btn btn-default mr-05">반영</button>
                        <button @click="storeTableClose('add')" type="button" class="btn btn-default">취소</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <div class="modal" :style="autogendlg && {'display': 'block'}">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="form-group text-center">
                        <h4>입력된 정보 기반으로 판매정보를 자동 생성 하시겠습니까?</h4>
                        <label class="control-label">(기존에 입력된 정보는 초기화됩니다.)</label>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" @click="closeAutoGen">취소</button>
                    <button type="button" class="btn btn-default" @click="autogenuseinf">확인</button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal" :style="regcnfdlg && {'display': 'block'}">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="form-group text-center">
                        <h4>상품을 등록하시겠습니까?</h4>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" @click="closeRegConfirm">취소</button>
                    <button type="button" class="btn btn-default" @click="doRequestReg">확인</button>
                </div>
            </div>
        </div>
    </div>
    <!-- 매장이미지2021-12-28추가 -->
    <div class="modal" :style="storeimgdlg && {'display': 'block'}">
        <div class="modal-dialog drag">
            <div class="modal-content">
                <div class="modal-header border-bottom-0">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeStoreImage">
                        <span aria-hidden="true">×</span>
                    </button>
                    대표 이미지
                </div>
                <div class="modal-body">
                    <div class="imgBoxDivGroup" v-if="showDragImg">
                        <div>
                            <div style="width:500px;height:400px">
                                <storeThumbnail ref="stfake"  style="width:500px;height:400px" v-if="fakemainImage.url != null" :newsubimguse="newsubimguse" v-model="fakemainImage.url" :imgtype="imgtype.GOODS" :imgFile="imgFile" :trueImg="trueImg" :change="onFakeMainImage" />
                            </div>
                            <div class="text-center mt-2">
                                <button type="button" class="btn btn-default" @click="imgReflect">반영</button>
                            </div>
                        </div>
                        <div class="imgDragbox" style="background: #dedede;">
                            <div class="imgDragbox-div">
                                <!-- {{ imgdragselect }} -->
                                <select class="form-control imgdragselect" v-model="imgdragselect" @change="storeImgList">
                                    <option v-for="(store,idx) in storeList" :key="idx" :value="store.storeCode" :selected="imgdragselect">{{ store.name }}</option>
                                </select>
                                <button @click="usestoreedit('represent')" type="button" class="btn btn-default">이용 가능 매장 수정</button>
                            </div>
                            <ul class="titleArr">
                                <li class="cls_click" v-for="(titem,idx) in titleArr" :key="idx" @click="titleArrClcik(titem)">
                                    <a>{{titem.title}}</a>
                                </li>
                            </ul>
                            <div>
                                <ul class="tab">
                                    <li v-for="title in storeTitleList" :key="title">{{ title }}</li>
                                </ul>
                            </div>
                            <div id="holder" class="dropImgBox" v-on:dragover="allowDrop" v-on:drop="ondrop($event,1)" @dragenter="onDragenter">
                                <img v-for="(img,idx) in imgDragList" :key="idx" class="imgboxChild" :src="img.url" :width="img.width" :height="img.height" draggable="true" v-on:dragstart="drag" :id="'imgidx'+idx">
                            </div>
                        </div>
                    </div>
                    <div style="height:400px" v-else>
                        <UseStore :noShowLabel="true" @brandkeyUpdatechilde="brandkeyUpdate" @brandstoresUpdatechilde="brandstoresUpdate" @tmselstoreschild="tmselstoresUpdate" @tselstoreschilde="tselstoresUpdate" :brandkey="brandkey" :goodsType="goodsType" :tmselstores="tmselstores" :serviceCondition="serviceCondition" :brandstores="brandstores" :tselstores="tselstores" />
                        <div class="text-center mt-2">
                            <button @click="storeAddSelect('represent')" type="button" class="btn btn-default mr-05">반영</button>
                            <button @click="storeTableClose('represent')" type="button" class="btn btn-default">취소</button>
                        </div>
                    </div>
                </div>
                <!-- <div class="modal-footer">
                </div> -->
            </div>
        </div>
    </div>
    <div style="display:none">{{bbo}}</div>
</section>
</template>

<script>
import {
    menuval,
    rescode,
    imgtype
} from "../../../lib/consts";
import routepath from "../../../lib/routes";
import storeThumbnail from "../../../components/storeThumbnail";
import SingleThumbnail from "../../../components/SingleThumbnail"
import StoreProdImg from "../../../components/StoreProdImg";
import ProdAddImg from "../../../components/ProdAddImg";
import DatePicker from "../../../components/DatePicker";
import MarkLbl from "../../../components/MarkLbl";
// import { getAgeGroupStr,  } from "../../../lib/utility";
import UseStore from "./component/UseStore.vue";
import PointCouponUserStore from "./component/PointCouponUserStore.vue";
import {
    getGoodsTypeStr,
    getMobileCoupon,
    getPercent,
    getStoreTypeStr
} from "../../../lib/utility";
import {
    Drag,
    Drop
} from "vue-drag-drop";
import {
    brandapi,
    b2bapi,
    goodsapi
} from "../../../lib/api";
import {
    reqGet,
    reqPost
} from "../../../lib/request";
import moment from 'moment';


export default {
    components: {
        PointCouponUserStore,
        storeThumbnail,
        SingleThumbnail,
        StoreProdImg,
        ProdAddImg,
        Drag,
        Drop,
        MarkLbl,
        DatePicker,
        UseStore,
    },
    created() {
        this.goodsType = this.$route.query.goodsType;
        this.copy = this.$route.query.copy;
        if (this.$route.query.goodsId > 0) {
            this.goodsId = this.$route.query.goodsId;
        } else {
            this.goodsId = 0;
        }
        this.$store.dispatch("doSetPath", {
            path1: menuval.LV1_PRD,
            path2: menuval.LV2_PRD_REG,
            title: "",
        });
    },
    computed: {
        routes() {
            return routepath;
        },
        authToken() {
            return this.$store.getters.authToken;
        },
        imgtype() {
            return imgtype;
        },
        getTotalStore() {
            var retval = 0;
            for (var idx = 0; idx < this.serviceCondition.serviceArea.brands.length; idx++) {
                if (typeof this.serviceCondition.serviceArea.brands[idx].stores != 'undefined' && this.serviceCondition.serviceArea.brands[idx].stores != null) {
                    retval = retval + this.serviceCondition.serviceArea.brands[idx].stores.length;
                }
            }
            return retval;
        },
      getPointCouponTotalStore() {
        var retval = 0;
        if(typeof this.pointCouponserviceCondition.useStoreArea.brands.length==0){
          retval = 0;
        }else{
          for (var idx = 0; idx < this.pointCouponserviceCondition.useStoreArea.brands.length; idx++) {
            if (typeof this.pointCouponserviceCondition.useStoreArea.brands[idx].stores != 'undefined' && this.pointCouponserviceCondition.useStoreArea.brands[idx].stores != null) {
              retval = retval + this.pointCouponserviceCondition.useStoreArea.brands[idx].stores.length;
            }
          }
        }

        return retval;
      },
    },
    data() {
        return {
            imgdragselect: null,
            newsubimguse: false,
            addStoreImgUse: false,
            showDragImg2: true,
            showDragImg: true,
            imgDragList: [],
            imgDragListOriginal: [],
            storeTitleList: [],
            storeList: [],
            exchn: [],
            exchn2: [],
            exchAn: [],
            bbo: [],
            copy: "",
            goodsTypesL: true,
            keywordType: "NoKeyword",
            keyword: "",
            content: [],
            content2: [],
            showmodal: false,
            comTrue: false,
            comTrue2: false,
            stepval: 0,
            addimgdlg: false,
            storeimgdlg: false,
            autogendlg: false,
            regcnfdlg: false,
            goodsType: "",
            goodsId: 0, //복사 상품 ID
            registerId: null, //임시 저장된 등록 대기 상품 ID. 만일 임시 저장하지 않고 바로 등록 요청하는 경우 null
            goodsType: null, //[상품 종류]MobileCoupon 모바일쿠폰, BookingCoupon 예약권, Booking 예약, MoneyCoupon 금액권, CashCoupon 캐시권
            introduction: {
                goodsName: "", //상품명
                goodsTag: null,
                intro: "", //상품소개
                mainImage: {
                    url: "", //메인 이미지 URL
                    width: 0, //메인 이미지 width
                    height: 0, //메인 이미지 height
                },
                subImages: [],
                forCombined: false,
                /*
                title             String      서브 이미지 제목
                description       String      서브 이미지 설명
                displayOrder      Number      서브 이미지 배열 순서
                images[].url      String      서브 이미지 URL
                images[].width    Number      서브 이미지 width
                images[].height   Number      서브 이미지 height
                */
            },
            fakemainImage: {
                url: '', //메인 이미지 URL
                width: 0, //메인 이미지 width
                height: 0, //메인 이미지 height
            },
            addsubimg: {
                title: "", //서브 이미지 제목
                description: "", //서브 이미지 설명
                displayOrder: 1, //서브 이미지 배열 순서
                images: [] //
                /*
                url      String      서브 이미지 URL
                width    Number      서브 이미지 width
                height   Number      서브 이미지 height
                */
            },
            editsubimgidx: -1,
            serviceCondition: {
                serviceArea: {
                    brands: [],
                    /*
                    brandCode:    String    이용 가능 브랜드 코드.
                    storeCodes:[]   Array     이용 가능 매장 코드
                    stores:[]
                    storeCode, storeName, storeType
                    */
                },
                timeCondition: {
                    hasSalesPeriod: false, //판매기간 제한 있음 여부
                    saleStartDate: "", //판매 시작일 (hasSalesPeriod 가 true 일 경우 사용)
                    saleEndDate: "", //판매 종료일( hasSalesPeriod 가 false 일 경우 사용
                    availableDateSetting: "SetDayCount", //유효기간 설정 타입    SetDayCount: 구매 후 며칠동안 유효한지 설정, SetFromToDate: 시작일과 종료일을 지정(모바일쿠폰/금액권/예약권 상품일 경우 입력)
                    availableDayCount: 60, //유효기간 날짜 수  (availableDateSetting이 SetDayCount일 경우 입력)
                    availableFromDate: "", //유효기간 시작일 (availableDateSetting이 SetFromToDate일 경우 입력)
                    availableToDate: "", //유효기간 종료일 (availableDateSetting이 SetFromToDate일 경우 입력)
                    cancellableDateSetting: "SetDayCount", //유효기간 설정 타입    SetDayCount: 구매 후 며칠동안 유효한지 설정, SetFromToDate: 시작일과 종료일을 지정(모바일쿠폰/금액권/예약권 상품일 경우 입력)
                    cancellableToDate: "", //유효기간 종료일 (availableDateSetting이 SetFromToDate일 경우 입력)
                    itemCancellableDayCount: 0, //구매취소 가능 일수. 취소불가일 경우 0을 입력 (모바일쿠폰/금액권/예약권 상품일 경우 입력)
                },
                useStoreArea:{}
            },
            brandkey: "",
            brandstores: [],
            tselstores: [],//
            tmselstores: [], //
            //여기
            pointCouponbrandkey: "",
            pointCoupontselstores: [],
            pointCoupontmselstores: [],
            pointCouponserviceCondition: {
              serviceArea: {
                brands: [],
                /*
                brandCode:    String    이용 가능 브랜드 코드.
                storeCodes:[]   Array     이용 가능 매장 코드
                stores:[]
                storeCode, storeName, storeType
                */
              },
              useStoreArea:{
                brands: [],
              }
            },
            pointCouponbrandstores: [],

            goodsOption: {
                hasOwnDeliveryPrice: false, //상품 별도로 입금가를 지정하여 사용할 경우 true
                options: [],
                /*
                optionName:"",//             String        옵션 이름
                mainOption:false,//             Boolean       대표옵션인 경우 true
                displayOrder:1,//           Number        표출 순서
                listPrice:"",//              String        제품 가격
                salePrice:"",//              String        판매 가격
                deliveryPrice:"",//          String        입금가. hasOwnDeliveryPrice 가 true 인 경우 필수 입력
                inventory:0,//              Number        판매 수량
                ageGroup:'Adult',//               String        성인, 어린이, 유아 구분(예약/예약권 상품일 경우 입력)
                                      [Adult, Child, Baby]
                headcount:0,//              Number        인원수  (예약/예약권 상품일 경우 입력)
                currencyCode:'KRW',//           String        통화 코드  [USD, KRW]
                */
            },
            usableHour: { //예약/예약권 상품일 경우 입력
                dayOfWeekType: "Weekday", //요일 타입 [Everyday, Weekday, Weekend, Custom]
                monday: false, //월요일 지정 여부 (dayOfWeekType 이 Custom 일 때 사용)
                tuesday: false, //화요일 지정 여부 (dayOfWeekType 이 Custom 일 때 사용)
                wednesday: false, //수요일 지정 여부 (dayOfWeekType 이 Custom 일 때 사용)
                thursday: false, //목요일 지정 여부 (dayOfWeekType 이 Custom 일 때 사용)
                friday: false, //금요일 지정 여부 (dayOfWeekType 이 Custom 일 때 사용)
                saturday: false, //토요일 지정 여부 (dayOfWeekType 이 Custom 일 때 사용)
                sunday: false, //일요일 지정 여부 (dayOfWeekType 이 Custom 일 때 사용)
                hours: [], //이용 시간 (입장 시간)
                unusableDays: [], //이용 불가일
            },
            addhours: 0,
            addminutes: 0,
            b2bChannel: {
                channelSalesAgreement: true, //외부채널 배포 동의 여부(모바일쿠폰/금액권/예약권 상품일 경우 입력)
                excludedChannels: [], //채널 배포 제외 리스트(모바일쿠폰/금액권/예약권 상품일 경우 입력)
                tablenjoyExcluded: true, //테이블엔조이배포여부
            },
            channels: [],
            channels2: [],
            channels3: [],
            channels4: [],
            defaultChan: [],
            thisVall: [],
            usage: {
                baseInfo: "", //기본정보
                useInfo: "", //사용정보
                notes: "", //유의사항
                returnsAndRefunds: "", //취소/환불 규정
            },
            maxuselimit: false, //제한없음  false : 제한없음, True:제한 있음
            maxusecount: 0, //최대 이용매수
            mindaylimit: false, //사전예약필수  false:필수아님   True:최소 일 전 까지 사전예약 필수
            minreservday: 0, //최소 일 전 까지 사전예약 필수
            showagegroup: false, //소인기준 false : 비노출, true:노출
            minage: 0, //
            maxage: 0, //
            parkmenu: false, //주차안내  false:주차불가, true:주차가능
            parkaddress: "", //주차장 주소
            opentime: false, //운영시간 false:비노출 true:노출
            openvalue: "", //운영시간
            unusableDate: "",
            trindex: "",
            optionId: '',
            optionName: '',
            listPrice: 0,
            salePrice: '',
            totalListPrice: 0,
            imgFile: {},
            trueImg: "",
            imgFile2: {},
            trueImg2: "",
            titleArr:[],
            useStoreToggle: false,
        };
    },
    mounted() {
        if (this.goodsId > 0) {
            this.refreshPage();
        }
    },
    methods: {
        sortlowestsub(sidx){
            if (sidx + 1 < this.introduction.subImages.length) {
                let t_array = this.introduction.subImages;
                const copyTarray = JSON.parse(JSON.stringify(t_array));

                t_array.splice(sidx,1);
                t_array.push(copyTarray[sidx]);

                this.introduction.subImages = t_array;
            }
        },
        sortTopsub(sidx){
            if (sidx > 0) {
                let t_array = this.introduction.subImages;
                const copyTarray = JSON.parse(JSON.stringify(t_array));

                t_array.splice(sidx,1);
                t_array.unshift(copyTarray[sidx]);

                this.introduction.subImages = t_array;
            }
        },
        titleArrClcik(titleArr) {
            // console.log(titleArr)
            this.imgDragList = [];
            titleArr.storeImages.forEach((el, idx) => {
                this.imgDragList.push({
                    url: el.url,
                    width: el.width,
                    height: el.height,
                })
            });
        },
        storeImgList() {
            reqGet(
                brandapi.base,
                brandapi.storeImageslist + "?storeCode=" + this.imgdragselect,
                this.authToken,
                (result) => {
                    if (result != null) {
                        if (result.code == rescode.REQ_SUCCESS) {
                            this.imgDragList = [];
                            this.imgDragListOriginal = [];
                            this.titleArr = [];
                            // console.log(result.data.list)
                            result.data.list.forEach(el => {
                                // console.log(.url)
                                this.titleArr.push({
                                    title: el.title,
                                    storeImages: el.storeImages
                                })
                                this.imgDragListOriginal = JSON.parse(JSON.stringify(this.imgDragList));
                            });
                            this.titleArrClcik(result.data.list[0]);
                        } else {
                            alert(result.message);
                        }
                    }
                }
            );
        },
        imgDragListUpdate(val, rib) {
            // const storeimgTrue = this.imgDragListOriginal.find(element => element.url === val);
            // console.log(storeimgTrue);
            // if (storeimgTrue !== undefined) {
            //     this.imgDragList.push(rib);
            // }
        },
        imgDragMainListUpdate(val,rib) {
            // const storeimgTrue = this.imgDragListOriginal.find(element => element.url === val);
            // // console.log(storeimgTrue);
            // if (storeimgTrue !== undefined) {
            //     this.imgDragList.push(rib[0]);
            // }
            // console.log(rib)
        },
        imgDragListDel(val, rib) {
            // let findss = this.imgDragList.filter(function (item) {
            //     return item.url !== val;
            // });
            // this.imgDragList = findss;
            // console.log(findss)
        },
        getsubFileData(val) {
            this.addsubimg.images = val
        },
        allowDrop(event) {
            event.preventDefault();
        },
        drag(event) { //드래그 시작시 호출 할 함수
            event.dataTransfer.setData("Text", event.target.id);
            const targetEl = document.getElementById('holder');
        },
        onDragenter(event) {
            event.preventDefault()
        },
        onDragover(event) {
            event.preventDefault()
        },
        storeAddSelect(type) {
            let newStoreNameB = [];
            // console.log(this.serviceCondition)
            this.serviceCondition.serviceArea.brands.forEach(el => {
                el.stores.forEach(el2 => {
                    newStoreNameB.push({
                        name: el.brandName + " " + el2.storeName,
                        storeCode: el2.storeCode
                    });
                    this.imgdragselect = el2.storeCode;
                });
            });
            this.storeList = newStoreNameB;
            if (type === 'represent') {
                this.showDragImg = true;
            } else if (type === 'none') {

            } else {
                this.showDragImg2 = true;
            }
            this.storeImgList();
        },
        storeTableClose(type) {
            if (type === 'represent') {
                this.showDragImg = true;
            } else {
                this.showDragImg2 = true;
            }
            this.storeList = [];
            this.serviceCondition.serviceArea.brands = [];
            this.imgDragList = [];
            this.imgDragListOriginal = [];
        },
        usestoreedit(type) {
            if (type === 'represent' || !type) {
                this.searchbrandstore();
                this.showDragImg = false;
            } else {
                this.searchbrandstore();
                this.showDragImg2 = false;
            }
        },
        brandstoresUpdate(brandstores) {
            this.brandstores = brandstores;
        },
        pointCouponbrandstoresUpdate(brandstores) {
          this.pointCouponbrandstores = brandstores;
        },
        tselstoresUpdate(tselstores) {
          this.tselstores = tselstores;
        },
        pointCoupontselstoresUpdate(tselstores) {
          this.pointCoupontselstores = tselstores;
        },
        tmselstoresUpdate(tmselstores) {
            this.tmselstores = tmselstores;
        },
        pointCoupontmselstoresUpdate(tmselstores) {
          this.pointCoupontmselstores = tmselstores;
        },
        brandkeyUpdate(brandkey) {
            this.brandkey = brandkey;
        },
        pointCouponbrandkeyUpdate(brandkey) {
          this.pointCouponbrandkey = brandkey;
        },
        ondrop(e, id, type, idx) {

        },
        storeimage() {
            this.storeimgdlg = true;
            this.newsubimguse = false;
            if (this.introduction.mainImage.url.trim().length == 0) {
                this.$refs.subImages.initFakeData();
                this.fakemainImage = {
                    url: '', //메인 이미지 URL
                    width: 0, //메인 이미지 width
                    height: 0, //메인 이미지 height
                };
            } else {
                this.fakemainImage.url = this.introduction.mainImage.url
                this.fakemainImage.width = this.introduction.mainImage.width
                this.fakemainImage.height = this.introduction.mainImage.height
            }
            this.storeAddSelect('none');
        },
        closeStoreImage() {
            this.storeimgdlg = false;
            this.showDragImg = true;
        },
        imgReflect() {
            this.introduction.mainImage.url = this.fakemainImage.url; //메인 이미지 url
            this.introduction.mainImage.width = this.fakemainImage.width; //메인 이미지 width
            this.introduction.mainImage.height = this.fakemainImage.height; //메인 이미지 height
            if (this.introduction.mainImage.url) {
                this.storeimgdlg = false;
            } else {
                alert('대표 이미지를 선택해주세요.');
                return;
            }
        },
        inputchecked(evt) {
            console.log(evt.target)
        },
        calculatedListPrice(idx, type) {
            if (type == "salePrice") {
                if (this.goodsOption.options.length <= idx) {
                    return 0;
                } else if (this.goodsOption.options[idx].childOptionIds == undefined || this.goodsOption.options[idx].childOptionIds == null) {
                    return 0;
                } else {
                    return this.goodsOption.options[idx].childOptionIds.reduce((acc, item) => Number(acc) + Number(item.salePrice), 0);
                }
            } else if (type == "inventory") {
                if (this.goodsOption.options.length <= idx) {
                    return 0;
                } else if (this.goodsOption.options[idx].childOptionIds == undefined || this.goodsOption.options[idx].childOptionIds == null) {
                    return 0;
                } else {
                    let pushArr = [];
                    for (var i = 0; i < this.goodsOption.options[idx].childOptionIds.length; i++) {
                        pushArr.push(this.goodsOption.options[idx].childOptionIds[i].inventory);
                    }
                    return Math.min.apply(null, pushArr)
                }
            } else {
                if (this.goodsOption.options.length <= idx) {
                    return 0;
                } else if (this.goodsOption.options[idx].childOptionIds == undefined || this.goodsOption.options[idx].childOptionIds == null) {
                    return 0;
                } else {
                    return this.goodsOption.options[idx].childOptionIds.reduce((acc, item) => Number(acc) + Number(item.listPrice), 0);
                }
            }
        },

        combinedChild(index, index2, goodsType2s) {

            // console.log(this.content)
            // this.content[index].goodsType
            // console.log(goodsType2s)
            if (this.bbo[this.bbo.length - 1] !== undefined) {
                if (this.bbo[this.bbo.length - 1] == 'MoneyCoupon' || this.bbo[this.bbo.length - 1] == 'MobileCoupon') {
                    if (goodsType2s == 'BookingCoupon') {
                        alert('상품 타입을 확인 해주세요.')
                        return;
                    }
                } else if (this.bbo[this.bbo.length - 1] == 'BookingCoupon') {
                    if (goodsType2s !== 'BookingCoupon') {
                        alert('상품 타입을 확인 해주세요.')
                        return;
                    }

                }
            }

            this.bbo.push(goodsType2s);
            let combinedChild = {
                optionId: this.content[index].options[index2].optionId,
                optionName: this.content[index].options[index2].optionName,
                listPrice: this.content[index].options[index2].listPrice,
                salePrice: this.content[index].options[index2].salePrice,
                inventory: this.content[index].options[index2].inventory,
                goodsName: this.content[index].goodsName,
                // goodsType: this.content[index].goodsType,
            }

            if (this.goodsOption.options[this.trindex].childOptionIds == null) {
                this.goodsOption.options[this.trindex].childOptionIds = [];
            }

            this.goodsOption.options[this.trindex].childOptionIds.push(combinedChild);
            this.goodsOption.options[this.trindex].listPrice = this.content[index].options[index2].listPrice;
            this.goodsOption.options[this.trindex].salePrice = this.content[index].options[index2].salePrice;

            //정상가
            // this.totalListPrice = this.goodsOption.options[this.trindex].childOptionIds.reduce((acc, item) => Number(acc) + Number(item.listPrice), 0);

            //판매가

        },
        rmvsubOption(ridx, ridx2) {
            if (confirm("세부옵션을 삭제하시겠습니까?")) {
                var t_mainOption = this.goodsOption.options[ridx].childOptionIds;
                console.log(t_mainOption)
                this.goodsOption.options[ridx].childOptionIds.splice(ridx2, 1);
            }
        },
        refreshPage2() {
            reqGet(
                goodsapi.base,
                goodsapi.combinedlist +
                "?keywordType=" + this.keywordType +
                "&keyword=" + this.keyword,
                this.authToken,
                (result) => {
                    if (result != null) {
                        if (result.code == rescode.REQ_SUCCESS) {
                            this.content = result.data;
                            console.log(this.content)
                        } else {
                            this.content = [];
                            alert(result.message);
                        }
                    }
                }
            )
        },
        closemodal() {
            this.showmodal = false;
        },
        onClickSearch(trindex) {
            if (this.goodsOption.options[0].childOptionIds.length == 0) {
                this.bbo = [];
            }
            this.showmodal = !this.showmodal;
            this.trindex = trindex;
        },
        clickgoodsType(val, comTrue, comTrue2) {
            this.goodsType = val;
            this.gotoStep_1(comTrue, comTrue2);
        },
        checkStep_1() {
            if (this.introduction.goodsName.trim().length == 0) {
                alert("상품명을 입력하세요.");
                return false;
            }
            if (this.introduction.mainImage.url.trim().length == 0) {
                alert("대표 이미지를 선택하세요.");
                return false;
            }

            if (this.introduction.subImages.length == 0) {
                alert("추가 이미지를 추가하세요.");
                return false;
            }

            for (var idx = 0; idx < this.introduction.subImages.length; idx++) {
                if (this.introduction.subImages[idx].images.length == 0) {
                    alert("추가 이미지를 추가하세요.");
                    return false;
                }
            }
            return true;
        },
        gotoStep(n) {
            if (this.stepval == 1) {
                if (!this.checkStep_1()) {
                    return;
                }
            } else if (this.stepval == 2) {
                if (!this.checkStep_2()) {
                    return;
                }
            } else if (this.stepval == 3) {
                if (!this.checkStep_3()) {
                    return;
                }
            } else if (this.stepval == 5) {
                if (!this.checkStep_5()) {
                    return;
                }
            }

            if (n == 0) {
                this.gotoStep_0();
            } else if (n == 1) {
                this.gotoStep_1(this.comTrue, this.comTrue2);
            } else if (n == 2) {
                this.gotoStep_2();
            } else if (n == 3) {
                this.gotoStep_3();
            } else if (n == 4) {
                this.gotoStep_4();
            } else if (n == 5) {
                this.gotoStep_5();
            } else if (n == 6) {
                this.gotoStep_6();
            }
        },
        gotoStep_0() {
            this.stepval = 0;
        },
        gotoStep_1(comTrue, comTrue2) {
            this.stepval = 1;
            this.comTrue = comTrue;
            this.comTrue2 = comTrue2;
        },
        gotoStep_2() {
            this.stepval = 2;
        },
        gotoStep_3() {
            this.searchbrandstore();
            this.stepval = 3;
            if(this.goodsType ==="PointCoupon"){
              this.pointCouponsearchbrandstore();
            }
        },
        gotoStep_4() {
            this.getgoodsSales();
            this.stepval = 4;
        },
        gotoStep_5() {
            this.stepval = 5;
        },
        gotoStep_6() {
            this.closeRegConfirm();
            this.stepval = 6;
        },
        closeAddImage() {
            this.addimgdlg = false;
        },
        showEditSubImage(selsubimg, selidx) {
            this.editsubimgidx = selidx;
            var new_images = selsubimg.images.map((item) => {
                return item
            });
            this.addsubimg = {
                ...selsubimg,
                images: new_images
            };
            this.$refs.subImages.edtImgData(this.addsubimg.images)
            this.addimgdlg = true;
        },
        emvsubimg(ridx) {
            this.introduction.subImages.splice(ridx, 1);
        },
        sortdownsub(sidx) {
            if (sidx + 1 < this.introduction.subImages.length) {
                var t_array = this.introduction.subImages;
                this.introduction.subImages = [];
                var s_val = t_array[sidx];
                t_array[sidx] = t_array[sidx + 1];
                t_array[sidx].displayOrder = sidx + 1;
                s_val.displayOrder = sidx + 2;
                t_array[sidx + 1] = s_val;
                this.introduction.subImages = t_array;
            }
        },
        sortupsub(sidx) {
            if (sidx > 0) {
                var t_array = this.introduction.subImages;
                this.introduction.subImages = [];
                var s_val = t_array[sidx];
                t_array[sidx] = t_array[sidx - 1];
                t_array[sidx].displayOrder = sidx + 1;
                s_val.displayOrder = sidx;
                t_array[sidx - 1] = s_val;
                this.introduction.subImages = t_array;
            }
        },
        showNewSubImage() {
            this.newsubimguse = true;
            this.editsubimgidx = -1;
            this.addStoreImgUse = false;
            if (this.storeList.length == 0) {
                this.storeList = [];
                this.serviceCondition.serviceArea.brands = [];
                this.imgDragList = [];
                this.imgDragListOriginal = [];
            }
            this.$refs.subImages.initFakeData();
            this.addsubimg = {
                title: "", //서브 이미지 제목
                description: "", //서브 이미지 설명
                displayOrder: 1, //서브 이미지 배열 순서
                images: [] //
            };
            this.addimgdlg = true;
        },
        closeAutoGen() {
            this.autogendlg = false;
        },
        showAutoGen() {
            // alert(this.comTrue2)
            if (this.comTrue2 == true) {
                if (this.goodsTypesL == true) {
                    alert('상품유형을 선택해 주세요.');
                    return
                }
            }
            this.autogendlg = true;
        },
        closeRegConfirm() {
            this.regcnfdlg = false;
        },
        checkStep_5() {
            if (this.usage.useInfo == "") {
                alert("사용정보를 입력하세요.");
                return false;
            }
            if (this.usage.baseInfo == "") {
                alert("기본정보를 입력하세요.");
                return false;
            }
            if (this.usage.notes == "") {
                alert("유의사항을 입력하세요.");
                return false;
            }
            if (this.usage.returnsAndRefunds == "") {
                alert("취소/환불 규정을 입력하세요.");
                return false;
            }
            return true;
        },
        showRegConfirm() {
            if (!this.checkStep_5()) {
                return;
            }
            this.regcnfdlg = true;
        },
        doRequestReg() {
            this.$store.dispatch('setDisabledLayout');

            var brands = this.serviceCondition.serviceArea.brands.map(bitem => {
                var t_storeCodes = bitem.stores.map(sitem => {
                    return sitem.storeCode
                });
                return {
                    brandCode: bitem.brandCode,
                    storeCodes: t_storeCodes
                }
            });
            var useStoreAreaBrands = null
            var t_serviceCondition = Object.assign({}, this.serviceCondition);
            t_serviceCondition.serviceArea = Object.assign({}, this.serviceCondition.serviceArea);
            t_serviceCondition.serviceArea.brands = brands;
            if(this.goodsType =='PointCoupon'){
              useStoreAreaBrands = this.pointCouponserviceCondition.useStoreArea.brands.map(bitem => {
                var t_storeCodes = bitem.stores.map(sitem => {
                  return sitem.storeCode
                });
                return {
                  brandCode: bitem.brandCode,
                  storeCodes: t_storeCodes
                }
              });
              if(!this.useStoreToggle){
                t_serviceCondition.useStoreArea = null
              }else{
                t_serviceCondition.useStoreArea = this.pointCouponserviceCondition.useStoreArea
                t_serviceCondition.useStoreArea.brands = useStoreAreaBrands;
              }
            }
            if(!this.useStoreToggle){
              this.pointCouponserviceCondition = {
                serviceArea: {
                  brands: [],
                },
                useStoreArea:{
                  brands: [],
                }
              }
            }

            var t_Option = this.goodsOption.options.map((oitem, oidx) => {
                return {
                    ...oitem,
                    displayOrder: oidx + 1
                }
            });
            this.goodsOption.options = t_Option;
            if (this.goodsType == "Combined") {
                this.goodsOption.options.forEach(goodsOption => {
                    goodsOption.listPrice = "0";
                    goodsOption.salePrice = "0";
                    goodsOption.inventory = "0";
                })
            }

            var t_subImages = this.introduction.subImages.map((sitem, sidx) => {
                return {
                    ...sitem,
                    displayOrder: sidx + 1
                }
            });
            this.introduction.subImages = t_subImages;

            let goodsOption2 = JSON.parse(JSON.stringify(this.goodsOption));
            goodsOption2.options.forEach(option => {
                option.childOptionIds = option.childOptionIds.map(childOptionIds => childOptionIds.optionId);
            });

            let b2bNewArr = this.exchAn;

            this.b2bChannel.excludedChannels.push(...b2bNewArr);
            console.log(this.b2bChannel.excludedChannels)
            // b2bNewArr.forEach((bnew,i) => {

            // })
            console.log(this.b2bChannel);
            var reqdata = {
                registerId: this.registerId,
                goodsType: this.goodsType,
                introduction: this.introduction,
                serviceCondition: t_serviceCondition,
                goodsOption: goodsOption2,
                b2bChannel: this.b2bChannel,
                usage: this.usage,
            };
            if (this.goodsType == "BookingCoupon" || this.goodsType == "Booking") {
                reqdata.usableHour = this.usableHour;
            }
            if (this.goodsType == "PointCoupon") {
              reqdata.serviceCondition.useStore = this.useStoreToggle;
            }else{
              reqdata.serviceCondition.useStore = null;
              reqdata.serviceCondition.useStoreArea = null
            }
            reqPost(
                goodsapi.base,
                goodsapi.regbrdrequest,
                this.authToken,
                reqdata,
                (result) => {
                    if (result != null) {
                        this.$store.dispatch('setDisabledLayout');
                        if (result.code == rescode.REQ_SUCCESS) {
                            alert("저장되었습니다.");
                            this.gotoStep_6();
                        } else {
                            alert(result.message);
                        }
                    }
                }
            );
        },

        goReqinspec() {
            this.$router.push(this.routes.prdreqinspec);
        },
        newRegInfo() { //추가등록
            this.registerId = null; //임시 저장된 등록 대기 상품 ID. 만일 임시 저장하지 않고 바로 등록 요청하는 경우 null
            this.goodsType = null; //[상품 종류]MobileCoupon 모바일쿠폰, BookingCoupon 예약권, Booking 예약, MoneyCoupon 금액권, CashCoupon 캐시권
            this.introduction = {
                goodsName: "", //상품명
                intro: "", //상품소개
                mainImage: {
                    url: "", //메인 이미지 URL
                    width: 0, //메인 이미지 width
                    height: 0, //메인 이미지 height
                },
                subImages: [],
            };
            this.addsubimg = {
                title: "", //서브 이미지 제목
                description: "", //서브 이미지 설명
                displayOrder: 1, //서브 이미지 배열 순서
                images: []
            };
            this.editsubimgidx = -1;
            this.serviceCondition = {
                serviceArea: {
                    brands: []
                },
                timeCondition: {
                    hasSalesPeriod: false, //판매기간 제한 있음 여부
                    saleStartDate: "", //판매 시작일 (hasSalesPeriod 가 true 일 경우 사용)
                    saleEndDate: "", //판매 종료일( hasSalesPeriod 가 false 일 경우 사용
                    availableDateSetting: "SetDayCount", //유효기간 설정 타입    SetDayCount: 구매 후 며칠동안 유효한지 설정, SetFromToDate: 시작일과 종료일을 지정(모바일쿠폰/금액권/예약권 상품일 경우 입력)
                    availableDayCount: 60, //유효기간 날짜 수  (availableDateSetting이 SetDayCount일 경우 입력)
                    availableFromDate: "", //유효기간 시작일 (availableDateSetting이 SetFromToDate일 경우 입력)
                    availableToDate: "", //유효기간 종료일 (availableDateSetting이 SetFromToDate일 경우 입력)
                    itemCancellableDayCount: 0, //구매취소 가능 일수. 취소불가일 경우 0을 입력 (모바일쿠폰/금액권/예약권 상품일 경우 입력)
                }
            };
            this.brandkey = "";
            this.brandstores = "";
            this.tselstores = [];
            this.tmselstores = [];
            this.goodsOption = {
                hasOwnDeliveryPrice: false, //상품 별도로 입금가를 지정하여 사용할 경우 true
                options: []
            };
            this.usableHour = { //예약/예약권 상품일 경우 입력
                dayOfWeekType: "Weekday", //요일 타입 [Everyday, Weekday, Weekend, Custom]
                monday: false, //월요일 지정 여부 (dayOfWeekType 이 Custom 일 때 사용)
                tuesday: false, //화요일 지정 여부 (dayOfWeekType 이 Custom 일 때 사용)
                wednesday: false, //수요일 지정 여부 (dayOfWeekType 이 Custom 일 때 사용)
                thursday: false, //목요일 지정 여부 (dayOfWeekType 이 Custom 일 때 사용)
                friday: false, //금요일 지정 여부 (dayOfWeekType 이 Custom 일 때 사용)
                saturday: false, //토요일 지정 여부 (dayOfWeekType 이 Custom 일 때 사용)
                sunday: false, //일요일 지정 여부 (dayOfWeekType 이 Custom 일 때 사용)
                hours: [], //이용 시간 (입장 시간)
            };
            this.addhours = 0;
            this.addminutes = 0;
            this.b2bChannel = {
                channelSalesAgreement: true, //외부채널 배포 동의 여부(모바일쿠폰/금액권/예약권 상품일 경우 입력)
                excludedChannels: [], //채널 배포 제외 리스트(모바일쿠폰/금액권/예약권 상품일 경우 입력)
                tablenjoyExcluded: true,
            };
            this.channels = [];
            this.usage = {
                baseInfo: "", //기본정보
                useInfo: "", //사용정보
                notes: "", //유의사항
                returnsAndRefunds: "", //취소/환불 규정
            };
            this.maxuselimit = false, //제한없음  false : 제한없음, True:제한 있음
                this.maxusecount = 0; //최대 이용매수
            this.mindaylimit = false, //사전예약필수  false:필수아님   True:최소 일 전 까지 사전예약 필수
                this.minreservday = 0; //최소 일 전 까지 사전예약 필수
            this.showagegroup = false; //소인기준 false : 비노출, true:노출
            this.minage = 0; //
            this.maxage = 0; //
            this.parkmenu = false; //주차안내  false:주차불가, true:주차가능
            this.parkaddress = ""; //주차장 주소
            this.opentime = false; //운영시간 false:비노출 true:노출
            this.openvalue = ""; //운영시간
            this.gotoStep_0();
        },
        goodsTypeVal(val) {
            return getGoodsTypeStr(val);
        },
        sumimagesort(drop, drag) {
            if (drag !== undefined) {
                if (drag.mark != 'subimgs') {
                    return;
                }
                var t_array = this.addsubimg.images;
                this.addsubimg.images = [];
                var b = t_array[drag.index];
                t_array[drag.index] = t_array[drop];
                t_array[drop] = b;
                this.addsubimg.images = t_array;
            }
        },
        onAddsubImg(idx, url, width, height) {

            this.addsubimg.images.push({
                url,
                width,
                height
            });
            // console.log(this.addsubimg.images)
        },
        onRmvSubImg(url) {
            this.addsubimg.images = url
        },
        onAddsubImages() {
            this.$refs.subImages.uploadImgArr();
            this.addsubimg.displayOrder = this.introduction.subImages.length + 1;
            var new_images = this.addsubimg.images.map((item) => {
                return item
            });
            if (new_images.length == 0) {
                alert("이미지를 추가하세요.");
                return;
            }
            this.introduction.subImages.push({
                ...this.addsubimg,
                images: new_images
            });
            this.addsubimg = {
                title: "", //서브 이미지 제목
                description: "", //서브 이미지 설명
                displayOrder: 1, //서브 이미지 배열 순서
                images: [] //
                /*
                url      String      서브 이미지 URL
                width    Number      서브 이미지 width
                height   Number      서브 이미지 height
                */
            };
            console.log(this.introduction.subImages)
            this.closeAddImage();
        },
        onMdfsubImages() {
            this.$refs.subImages.uploadImgArr();
            var new_images = this.addsubimg.images.map((item) => {
                return item
            });
            if (new_images.length == 0) {
                alert("이미지를 추가하세요.");
                return;
            }
            this.introduction.subImages[this.editsubimgidx] = {
                ...this.addsubimg,
                images: new_images
            };
            this.addsubimg = {
                title: "", //서브 이미지 제목
                description: "", //서브 이미지 설명
                displayOrder: 1, //서브 이미지 배열 순서
                images: [] //
                /*
                url      String      서브 이미지 URL
                width    Number      서브 이미지 width
                height   Number      서브 이미지 height
                */
            };
            this.editsubimgidx = -1;
            this.closeAddImage();
        },
        isMobile(val) {
            return getMobileCoupon(val);
        },
        isBooking(val) {
            return val == "Booking";
        },
        getHourFormat(val) {
            const duration = moment.duration(val);
            var hours = duration.hours() + "";
            var minutes = duration.minutes() + "";
            return hours.padStart(2, '0') + ":" + minutes.padStart(2, '0');
        },
        getUnusableDayFormat(val) {
            return moment(val).format('YYYY-MM-DD');
        },
        addUsableHour() {
            var hours = this.addhours + "";
            var minutes = this.addminutes + "";
            var newtime = hours.padStart(2, '0') + ":" + minutes.padStart(2, '0') + ":00";
            var tmp_array = this.usableHour.hours;
            tmp_array.push(newtime);
            tmp_array = tmp_array.map(hitem => {
                return moment.duration(hitem).asMilliseconds()
            });
            tmp_array.sort(function (a, b) {
                return a - b
            });
            this.usableHour.hours = tmp_array.map(msitem => {
                var msdur = moment.duration(msitem, 'milliseconds');
                var mshours = msdur.hours() + "";
                var msminutes = msdur.minutes() + "";
                return mshours.padStart(2, '0') + ":" + msminutes.padStart(2, '0') + ":00";
            });
            this.addhours = 0;
            this.addminutes = 0;
        },
        addUnusableDay() {
            if (!this.unusableDate) return false;

            var newDays = moment(this.unusableDate).format('YYYYMMDD');
            var tmp_array = this.usableHour.unusableDays;

            tmp_array.push(newDays);
            tmp_array = tmp_array.map((hitem) => {
                return moment(hitem).format('YYYYMMDD');
            });
            tmp_array.sort(function (a, b) {
                return a - b;
            });
            this.usableHour.unusableDays = tmp_array.map((msitem) => {
                return (
                    moment(msitem).format('YYYY-MM-DD')
                );
            });
            this.unusableDate = "";
        },
        rmvhours(ridx) {
            this.usableHour.hours.splice(ridx, 1);
        },
        rmvUnusableDays(ridx) {
            this.usableHour.unusableDays.splice(ridx, 1);
        },
        onmonday() {
            this.usableHour.monday = !this.usableHour.monday;
        },
        ontuesday() {
            this.usableHour.tuesday = !this.usableHour.tuesday;
        },
        onwednesday() {
            this.usableHour.wednesday = !this.usableHour.wednesday;
        },
        onthursday() {
            this.usableHour.thursday = !this.usableHour.thursday;
        },
        onfriday() {
            this.usableHour.friday = !this.usableHour.friday;
        },
        onsaturday() {
            this.usableHour.saturday = !this.usableHour.saturday;
        },
        onsunday() {
            this.usableHour.sunday = !this.usableHour.sunday;
        },
        addOption() {
            var noption = {
                optionName: "", //옵션 이름
                mainOption: false, //대표옵션인 경우 true
                displayOrder: 1, //표출 순서
                listPrice: "", //제품 가격
                salePrice: "", //판매 가격
                deliveryPrice: "", //입금가. hasOwnDeliveryPrice 가 true 인 경우 필수 입력
                inventory: 0, //판매 수량
                ageGroup: null, //성인, 어린이, 유아 구분(예약/예약권 상품일 경우 입력)[Adult, Child, Baby]
                headcount: null, //인원수  (예약/예약권 상품일 경우 입력)
                currencyCode: 'KRW', //통화 코드  [USD, KRW]
                childOptionIds: [],
            };

            this.goodsOption.options.push(noption);
        },
        optionsort(drop, drag) {
            if (drag.mark != 'option') {
                return;
            }
            var t_array = this.goodsOption.options;
            this.goodsOption.options = [];
            var b = t_array[drag.index];
            t_array[drag.index] = t_array[drop];
            t_array[drop] = b;
            this.goodsOption.options = t_array;
        },
        rmvoption(ridx) {
            if (confirm("옵션에 포함된 세부옵션이 모두 삭제됩니다. 삭제하시겠습니까?")) {
                this.bbo = [];
                var t_mainOption = this.goodsOption.options[ridx].mainOption;
                this.goodsOption.options.splice(ridx, 1);
                if (t_mainOption && this.goodsOption.options.length > 0) {
                    this.goodsOption.options[0].mainOption = t_mainOption;
                }
            }
        },

        onmainOption(idx) {
            var t_options = this.goodsOption.options.map(oitem => {
                return {
                    ...oitem,
                    mainOption: false
                }
            });
            t_options[idx].mainOption = true;
            this.goodsOption.options = t_options;
        },
        percent(nval, oval) {
            return getPercent(nval, oval);
        },
        searchbrandstore() {
            reqGet(
                brandapi.base,
                brandapi.storesquery + "?brandNameContaining=" + this.brandkey,
                this.authToken,
                (result) => {
                    if (result != null && result.code == rescode.REQ_SUCCESS) {
                        this.brandstores = result.data.brands;
                    }
                }
            );
        },
        pointCouponsearchbrandstore() {
          reqGet(
            brandapi.base,
            brandapi.storesquery + "?brandNameContaining=" + this.pointCouponbrandkey,
            this.authToken,
            (result) => {
              if (result != null && result.code == rescode.REQ_SUCCESS) {
                this.pointCouponbrandstores = result.data.brands;
              }
            }
          );
        },
        isNotSelStore(brandCode, storeCode) {
            var bidx = this.serviceCondition.serviceArea.brands.findIndex(bitem => bitem.brandCode == brandCode);
            if (bidx == -1) {
                return true;
            }
            var bitem = this.serviceCondition.serviceArea.brands[bidx];
            if (typeof bitem.stores === 'undefined' || bitem.stores === null) {
                return true;
            }
            var sidx = bitem.stores.findIndex(sitem => sitem.storeCode == storeCode);
            if (sidx == -1) {
                return true;
            }
            return false;
        },
        onTselStore(brandCode, brandName, storeCode, storeName, storeType) {
            var tidx = this.tselstores.findIndex(titem => titem.brandCode == brandCode && titem.storeCode == storeCode);
            if (tidx == -1) {
                var nval = {
                    brandCode,
                    brandName,
                    storeCode,
                    storeName,
                    storeType
                };
                this.tselstores.push(nval);
            } else {
                this.tselstores.splice(tidx, 1);
            }
        },
        isTselStore(brandCode, storeCode) {
            var tidx = this.tselstores.findIndex(titem => titem.brandCode == brandCode && titem.storeCode == storeCode);
            if (tidx > -1) {
                return true;
            }
            return false;
        },
        onTMselStore(brandCode, brandName, storeCode, storeName, storeType) {
            var tidx = this.tmselstores.findIndex(titem => titem.brandCode == brandCode && titem.storeCode == storeCode);
            if (tidx == -1) {
                var nval = {
                    brandCode,
                    brandName,
                    storeCode,
                    storeName,
                    storeType
                };
                this.tmselstores.push(nval);
            } else {
                this.tmselstores.splice(tidx, 1);
            }
        },
        onCancellableDayCount() {
            this.serviceCondition.timeCondition.itemCancellableDayCount = 100;
        },
        isTMselStore(brandCode, storeCode) {
            var tidx = this.tmselstores.findIndex(titem => titem.brandCode == brandCode && titem.storeCode == storeCode);
            if (tidx > -1) {
                return true;
            }
            return false;
        },
        addMyServicestore() {
            for (var idx = 0; idx < this.tselstores.length; idx++) {
                var bidx = this.serviceCondition.serviceArea.brands.findIndex(bitem => bitem.brandCode == this.tselstores[idx].brandCode);
                if (bidx == -1) {
                    var nbval = {
                        brandCode: this.tselstores[idx].brandCode,
                        brandName: this.tselstores[idx].brandName,
                        storeCodes: [],
                        stores: [{
                            storeCode: this.tselstores[idx].storeCode,
                            storeName: this.tselstores[idx].storeName,
                            storeType: this.tselstores[idx].storeType,
                        }]
                    };
                    this.serviceCondition.serviceArea.brands.push(nbval);
                } else {
                    this.serviceCondition.serviceArea.brands[bidx].stores.push({
                        storeCode: this.tselstores[idx].storeCode,
                        storeName: this.tselstores[idx].storeName,
                        storeType: this.tselstores[idx].storeType,
                    });
                }
            }
            this.tselstores = [];
        },
        rmvMyServicestore() {
            for (var idx = 0; idx < this.tmselstores.length; idx++) {
                var bidx = this.serviceCondition.serviceArea.brands.findIndex(bitem => bitem.brandCode == this.tmselstores[idx].brandCode);
                if (bidx > -1) {
                    var bitm = this.serviceCondition.serviceArea.brands[bidx];
                    var sidx = bitm.stores.findIndex(sitem => sitem.storeCode == this.tmselstores[idx].storeCode);
                    if (sidx > -1) {
                        this.serviceCondition.serviceArea.brands[bidx].stores.splice(sidx, 1);
                    }
                }
            }
            this.tmselstores = [];
        },
        getStoreType(val) {
            return getStoreTypeStr(val);
        },
        isAgreeChannel(chcode) {
            if (this.b2bChannel.excludedChannels.findIndex(item => item == chcode) == -1) {
                return true;
            } else {
                return false;
            }
        },
        onchangechannel(chcode, event) {
            if (event.target.checked) {
                var idx = this.b2bChannel.excludedChannels.findIndex(item => item == chcode);
                if (idx != -1) {
                    this.b2bChannel.excludedChannels.splice(idx, 1);
                }
            } else {
                this.b2bChannel.excludedChannels.push(chcode);
            }
        },
        getgoodsSales() {
            this.goodsSaParant();
        },
        async goodsSaParant() {
            let nonCombinedOnly = false;
            if (!this.comTrue) {
                // alert('this.comTrue')
                nonCombinedOnly = true;
            } else {
                nonCombinedOnly = false
            }
            await reqGet(
                b2bapi.base,
                b2bapi.channelList + "?manageType=GoodsSales" + "&nonCombinedOnly=" + nonCombinedOnly,
                this.authToken,
                (result) => {
                    if (result != null && result.code == rescode.REQ_SUCCESS) {
                        this.channels = result.data.channels;
                        this.thisVall = result.data.channels;
                        this.channels2 = result.data.channels[0];
                        console.log('1')
                    }
                }
            );
            await this.goodsSalesChild();
        },
        async goodsSalesChild() {
            await reqGet(
                b2bapi.base,
                b2bapi.channelList + "?manageType=GoodsSales" + "&nonCombinedOnly=" + false,
                this.authToken,
                (result) => {
                    if (result != null && result.code == rescode.REQ_SUCCESS) {
                        //기존배열
                        this.channels3 = result.data.channels;
                        // this.channels4 = this.channels3.concat(this.channels);
                        this.channels4 = this.channels3;

                        this.thisVall.forEach((el, idx) => {
                            //combinde채널리스트삭제 배열
                            this.defaultChan.push(el.channelCode);
                        });
                        this.exchn2 = [];
                        this.channels4.forEach((el, idx) => {
                            //기존 배열
                            this.exchn.push(el.channelCode);
                            this.exchn2.push(el.channelCode);
                            // console.log(el.channelCode)

                        });
                        //원본
                        console.log('2')

                        //  console.log(this.channels)
                        console.log(this.defaultChan)
                        this.exchAn = this.exchn2.filter(x => !this.defaultChan.includes(x))

                        // console.log(this.exchAn)

                    }
                }
            );
        },
        autogenuseinf() {
            this.closeAutoGen();
            //usage.useInfo                                String        사용정보
            var usestore = ""; //사용장소정보
            for (var bidx = 0; bidx < this.serviceCondition.serviceArea.brands.length; bidx++) {
                for (var sidx = 0; sidx < this.serviceCondition.serviceArea.brands[bidx].stores.length; sidx++) {
                    if (usestore != "") {
                        usestore += ",";
                    }
                    usestore += this.serviceCondition.serviceArea.brands[bidx].brandName + " " + this.serviceCondition.serviceArea.brands[bidx].stores[sidx].storeName;
                }
            }
            if (!this.comTrue2) {
                var availableDate = ""; //유효기간
                if (this.serviceCondition.timeCondition.availableDateSetting == 'SetDayCount') {
                    availableDate = "구매 후 " + this.serviceCondition.timeCondition.availableDayCount + "일";
                } else {
                    availableDate = this.serviceCondition.timeCondition.availableFromDate + " ~ " + this.serviceCondition.timeCondition.availableToDate;
                }
            } else {
                var availableDate = "";
            }

            var maxlimit = ""; //최대 이용매수
            if (this.maxuselimit == false) {
                maxlimit = "해당 상품은 매수 제한없이 사용 가능합니다.";
            } else {
                maxlimit = "해당 상품은 일행당 " + this.maxusecount + "매 사용 가능합니다.";
            }

            var minlimit = ""; //사전예약필수;
            if (this.mindaylimit == false) {
                minlimit = "원활한 이용을 위해 예약을 권장합니다.";
            } else {
                minlimit = "반드시 " + this.minreservday + "일전 사전 예약 후 이용 가능합니다.";
            }

            var agegroup = ""; //소인기준;
            if (this.showagegroup) {
                agegroup = "소인기준 : " + this.minage + "세 ~ " + this.maxage + "세";
            }

            var parkaddr = "";
            if (this.parkmenu == false) {
                parkaddr = "주차불가";
            } else {
                parkaddr = this.parkaddress;
            }

            var opentval = "";
            if (this.opentime) {
                opentval = "운영시간 : " + this.openvalue;
            }
            if (this.comTrue2) { // 결합상품일경우
                if (this.goodsTypesL == 'mobileCoupons' || this.goodsTypesL == 'moneyCoupons') {
                    this.usage.useInfo = "사용장소 : " + usestore;
                    this.usage.useInfo = this.usage.useInfo + "\n유효기간 : " + availableDate;
                    this.usage.useInfo = this.usage.useInfo + "\n" + maxlimit;
                    this.usage.useInfo = this.usage.useInfo + "\n" + minlimit
                    +"\n"+ '예약은 매장에 전화예약 부탁드립니다.' + "\n" + '(매장에 이용문의 시 테이블엔조이에서 구매했다고 말씀부탁드립니다.)';
                    if (agegroup != "") {
                        this.usage.useInfo = this.usage.useInfo + "\n" + agegroup;
                    }
                    this.usage.useInfo = this.usage.useInfo + "\n주차안내 : " + parkaddr;
                    if (opentval != "") {
                        this.usage.useInfo = this.usage.useInfo + "\n" + opentval;
                    }
                } else if (this.goodsTypesL == 'BookingCoupon') {
                    this.usage.useInfo = '*매장에 문의사항이 있는 경우 테이블엔조이에서 구매했다고 말씀 부탁드립니다.\n\n' + "사용장소 : " + usestore;
                    this.usage.useInfo = this.usage.useInfo + "\n유효기간 : " + availableDate;
                    this.usage.useInfo = this.usage.useInfo + "\n" + maxlimit;
                    this.usage.useInfo = this.usage.useInfo + "\n" + minlimit;
                    if (agegroup != "") {
                        this.usage.useInfo = this.usage.useInfo + "\n" + agegroup;
                    }
                    this.usage.useInfo = this.usage.useInfo + "\n주차안내 : " + parkaddr;
                    if (opentval != "") {
                        this.usage.useInfo = this.usage.useInfo + "\n" + opentval;
                    }

                    this.usage.useInfo += "\n\n▶ 예약권 이용안내";
                    this.usage.useInfo += "\n해당 상품은 온라인 예약이 필수인 예약 필수 상품입니다.";
                    this.usage.useInfo += "\n예약없이 방문 시, 테이블 및 메뉴 등 사전에 준비되지 않아 이용이 불가 합니다.";
                    this.usage.useInfo += "\n반드시 쿠폰 구매 시 발송되는 모바일쿠폰을 통해 온라인 예약을 진행해 주세요.";
                    this.usage.useInfo += "\n예약 확정 문자 수신 후 매장에 방문하셔야 합니다.";
                    this.usage.useInfo += "\n예약 및 예약 확정 문자 없이 방문한 경우에는 이용이 불가 합니다.";
                    this.usage.useInfo += "\n자세한 이용 문의는 고객센터로 연락 주세요. (1600-3662 / 09:00~12:00)";

                    this.usage.useInfo += "\n\n▶ 온라인 예약 이용방법";
                    this.usage.useInfo += "\n1. 발송되는 카카오 알림톡 내 “날짜 지정하기＂를 통하여 예약 페이지로 이동 합니다.";
                    this.usage.useInfo += "\n  (e쿠폰함의 경우 잔액확인에 있는 URL을 통해 예약페이지로 이동합니다. )";
                    this.usage.useInfo += "\n2. URL(날짜 지정하기) 클릭 하여 예약 페이지로 이동 합니다.";
                    this.usage.useInfo += "\n3. 예약 신청 후 “예약완료 알림문자＂를 수신합니다. (매장에 따라 약 1일 소요)";
                    this.usage.useInfo += "\n4. 매장 방문 후 “예약완료 알림문자＂를 보여주시고, 고객님의 성함을 말씀해주세요.";
                    this.usage.useInfo += "\n※ 예약을 하지 않거나 “예약완료 알림문자” 없이 방문 시에는 이용이 불가 합니다.";
                }
            } else {// 결합상품이 아닌 일반 상품일경우

                if (this.goodsType == 'MobileCoupon' || this.goodsType == 'MoneyCoupon') { //모바일쿠폰, 모바일금액권
                    this.usage.useInfo = "사용장소 : " + usestore;
                    this.usage.useInfo = this.usage.useInfo + "\n유효기간 : " + availableDate;
                    this.usage.useInfo = this.usage.useInfo + "\n" + maxlimit;
                    this.usage.useInfo = this.usage.useInfo + "\n" + minlimit
                    +"\n"+ '예약은 매장에 전화예약 부탁드립니다.' + "\n" + '(매장에 이용문의 시 테이블엔조이에서 구매했다고 말씀부탁드립니다.)';
                    if (agegroup != "") {
                        this.usage.useInfo = this.usage.useInfo + "\n" + agegroup;
                    }
                    this.usage.useInfo = this.usage.useInfo + "\n주차안내 : " + parkaddr;
                    if (opentval != "") {
                        this.usage.useInfo = this.usage.useInfo + "\n" + opentval;
                    }
                } else if (this.goodsType == 'BookingCoupon' || this.goodsTypesL == 'BookingCoupon') { //예약권
                    this.usage.useInfo = '*매장에 문의사항이 있는 경우 테이블엔조이에서 구매했다고 말씀 부탁드립니다.\n\n' + "사용장소 : " + usestore;
                    this.usage.useInfo = this.usage.useInfo + "\n유효기간 : " + availableDate;
                    this.usage.useInfo = this.usage.useInfo + "\n" + maxlimit;
                    this.usage.useInfo = this.usage.useInfo + "\n" + minlimit;
                    if (agegroup != "") {
                        this.usage.useInfo = this.usage.useInfo + "\n" + agegroup;
                    }
                    this.usage.useInfo = this.usage.useInfo + "\n주차안내 : " + parkaddr;
                    if (opentval != "") {
                        this.usage.useInfo = this.usage.useInfo + "\n" + opentval;
                    }

                    this.usage.useInfo += "\n\n▶ 예약필수쿠폰 이용안내";
                    this.usage.useInfo += "\n해당 상품은 온라인 예약이 필수인 예약 필수 상품입니다.";
                    this.usage.useInfo += "\n예약없이 방문 시, 테이블 및 메뉴 등 사전에 준비되지 않아 이용이 불가 합니다.";
                    this.usage.useInfo += "\n상품을 구매하시면 카카오 알림톡 또는 문자메세지로 쿠폰이 전송 됩니다.";
                    this.usage.useInfo += "\n쿠폰에 있는 “날짜 지정하기＂를 통해 온라인 예약을 진행해 주세요.";
                    this.usage.useInfo += "\n예약완료 알림문자 수신 후 매장에 방문하셔야 합니다.";
                    this.usage.useInfo += "\n자세한 이용 문의는 고객센터로 연락 주세요.";
                    this.usage.useInfo += "\n유선문의 : 1600-3662 / 09:00~12:00";
                    this.usage.useInfo += "\n카카오톡 1:1 문의하기 : @테이블엔조이 검색 / 09:00 ~ 16:00";

                    this.usage.useInfo += "\n\n▶ 온라인 예약 이용방법";
                    this.usage.useInfo += "\n1. 발송되는 카카오 알림톡 내 “날짜 지정하기＂를 통하여 예약 페이지로 이동 합니다.";
                    this.usage.useInfo += "\n  (e쿠폰함의 경우 잔액확인에 있는 URL을 통해 예약페이지로 이동합니다. )";
                    this.usage.useInfo += "\n2. 사용할 쿠폰을 선택 후 이용하실 날짜와 시간을 선택합니다.";
                    this.usage.useInfo += "\n3. 예약 신청 후 “예약완료 알림문자＂를 수신합니다. (매장에 따라 약 1일 소요)";
                    this.usage.useInfo += "\n4. 매장 방문 후 “예약완료 알림문자＂를 보여주시고, 고객님의 성함을 말씀해주세요.";
                    this.usage.useInfo += "\n※ 예약을 하지 않거나 “예약완료 알림문자” 없이 방문 시에는 이용이 불가 합니다.";
                } else if (this.goodsType == 'Booking') { //예약
                    this.usage.useInfo = maxlimit;
                    if (agegroup != "") {
                        this.usage.useInfo = this.usage.useInfo + "\n" + agegroup;
                    }
                    this.usage.useInfo = this.usage.useInfo + "\n주차안내 : " + parkaddr;
                    if (opentval != "") {
                        this.usage.useInfo = this.usage.useInfo + "\n" + opentval;
                    }
                } else if (this.goodsType == 'PointCoupon'){
                  this.usage.useInfo = "이용매장 : " + usestore;
                  this.usage.useInfo = this.usage.useInfo + "\n유효기간 : " + availableDate;
                  this.usage.useInfo += "\n기재된 유효기간까지 테이블엔조이 사이트에서 사용 가능 합니다.";
                  this.usage.useInfo += "\n매수 제한없이 사용 가능합니다.";
                  this.usage.useInfo += "\n부족한 금액은 타 결제수단과 복합으로 사용 가능합니다.";

                }

            }

            var today = moment().format("YYYY-MM-DD");
            //usage.baseInfo                               String        기본정보
            if (this.goodsType == 'Booking') { //예약
                this.usage.baseInfo = "해당 쿠폰은 테이블엔조이에서 발행되었습니다.";
                this.usage.baseInfo += "\n해당 쿠폰은 지급보증 및 피해보상 보험 계약 없이 테이블엔조이의 신용으로 발행합니다.";
                this.usage.baseInfo += "\n할인율은 " + today + " 해당 매장의 메뉴판 판매가 기준으로 산정되었습니다.";
                this.usage.baseInfo += "\n테이블엔조이에서 판매되는 상품과는 중복 사용이 가능합니다.";
                this.usage.baseInfo += "\n단, 타 할인 및 쿠폰, 현장이벤트와 중복은 불가합니다.";
                this.usage.baseInfo += "\n부가세 포함 가격";
            } else if (this.goodsTypesL == 'mobileCoupons' || this.goodsTypesL == 'moneyCoupons' || this.goodsTypesL == 'BookingCoupon' || this.goodsType == 'MobileCoupon' || this.goodsType == 'MoneyCoupon' || this.goodsType == 'BookingCoupon') { //모바일쿠폰, 모바일금액권, 예약권
                this.usage.baseInfo = "해당 쿠폰은 테이블엔조이에서 발행되었습니다.";
                this.usage.baseInfo += "\n해당 쿠폰은 지급보증 및 피해보상 보험 계약 없이 테이블엔조이의 신용으로 발행합니다.";
                this.usage.baseInfo += "\n할인율은 " + today + " 해당 매장의 메뉴판 판매가 기준으로 산정되었습니다.";
                this.usage.baseInfo += "\n상품 구매 시, 카카오 알림톡 또는 문자로 모바일 쿠폰이 발송 됩니다.";
                this.usage.baseInfo += "\n테이블엔조이에서 판매되는 상품과는 중복 사용이 가능합니다.";
                this.usage.baseInfo += "\n단, 타 할인 및 쿠폰, 현장이벤트와 중복은 불가합니다.";
                this.usage.baseInfo += "\n부가세 포함 가격";
            }else if (this.goodsTypesL == 'pointCoupon' || this.goodsType == 'PointCoupon'){
                this.usage.baseInfo = "해당 쿠폰은 테이블엔조이에서 발행되었습니다.";
                this.usage.baseInfo += "\n해당 쿠폰은 지급보증 및 피해보상 보험 계약 없이 테이블엔조이의 신용으로 발행합니다.";
                this.usage.baseInfo += "\n상품 구매 시, 카카오 알림톡 또는 문자로 모바일 쿠폰이 발송 됩니다.";
            }
            //usage.notes                                  String        유의사항
            if (this.goodsType == 'Booking') { //예약
                this.usage.notes = "공휴일 & 특정일 (발렌타인데이, 어린이날, 크리스마스 이브 등) 및 12월 연말시즌에는 \n별도의 특선 상품 또는 주말 상품으로 운영될 수 있습니다.";
            } else if (this.goodsTypesL == 'mobileCoupons' || this.goodsTypesL == 'moneyCoupons' || this.goodsTypesL == 'BookingCoupon' || this.goodsType == 'MobileCoupon' || this.goodsType == 'MoneyCoupon' || this.goodsType == 'BookingCoupon') { //모바일쿠폰, 모바일금액권, 예약권
                this.usage.notes = "공휴일 & 특정일 (발렌타인데이, 어린이날, 크리스마스 이브 등) 및 12월 연말시즌에는 \n별도의 특선 상품 또는 주말 상품으로 운영될 수 있습니다.";
                this.usage.notes += "\n반드시 구매 전 매장으로 문의 후 이용해 주세요.";
                this.usage.notes += "\n해당 쿠폰은 제 3자에게로 매매가 허용되지 않습니다.";
                this.usage.notes += "\n개인간 거래를 통해 취득한 쿠폰은 사용이 제한될 수 있습니다.";
                this.usage.notes += "\n쿠폰의 내용을 추가 또는 삭제하여 재 배포한 경우, 해당 쿠폰의 사용이 제한될 수 있습니다.";
                this.usage.notes += "\n구매 후 가격이 인상되는 경우에도 유효기간 이내에는 동일한 조건으로 이용이 가능 합니다.\n단, 매장 사정에 따라 이용이 어려운 경우 100% 환불 됩니다.";
                this.usage.notes += "\n유효기간이 만료된 쿠폰은 사용하실 수 없습니다.";
            }else if (this.goodsTypesL == 'pointCoupon' || this.goodsType == 'PointCoupon'){
              this.usage.notes = "해당 쿠폰은 제 3자에게로 매매가 허용되지 않습니다.";
              this.usage.notes += "\n개인간 거래를 통해 취득한 쿠폰은 사용이 제한될 수 있습니다.";
              this.usage.notes += "\n쿠폰의 내용을 추가 또는 삭제하여 재 배포한 경우, 해당 쿠폰의 사용이 제한될 수 있습니다.";
              this.usage.notes += "\n유효기간이 만료된 쿠폰은 사용하실 수 없습니다.";
            }

            var cancellableDay = ""; //취소기한(사용조건)
            if (this.serviceCondition.timeCondition.itemCancellableDayCount == 0) {
                cancellableDay = "취소 요청 시, 구매 금액의 90%가 환불됩니다.";
            } else {
                cancellableDay = "구매 후 " + this.serviceCondition.timeCondition.itemCancellableDayCount + "일 이내 취소 요청 시, 100% 환불됩니다. ";
                cancellableDay += "\n구매 후 " + this.serviceCondition.timeCondition.itemCancellableDayCount + "일 이후 취소 요청 시, 구매 금액의 90%가 환불됩니다.";
            }
            //usage.returnsAndRefunds                      String        취소/환불 규정
            if (this.goodsType == 'MobileCoupon' || this.goodsTypesL == 'mobileCoupons') { //모바일쿠폰
                this.usage.returnsAndRefunds = cancellableDay;
                this.usage.returnsAndRefunds += "\n매장의 귀책(폐업, 품절, 재료소진 등)으로 인하여 서비스 제공이 불가한 경우에는 100%환불 됩니다.";
                this.usage.returnsAndRefunds += "\n최초 유효기간이 만료된 경우 유효기간 연장을 신청하실 수 있습니다.";
                this.usage.returnsAndRefunds += "\n단, 현재 같은 가격과 구성으로 동일한 상품이 판매되고 있는 경우에만 가능 합니다.";
                this.usage.returnsAndRefunds += '\n"최초 유효기간 이란?" 상품구매 시 최초로 부여되는 유효기간 (연장 이후 기간 제외)';
                this.usage.returnsAndRefunds +=
                    '\n고객센터 문의 (TEL: 1600-3662) - 평일 09:00 ~ 12:00 (주말,공휴일 휴무)' +
                    '\n카카오톡 1:1 채팅 문의 - 평일 09:00 ~ 16:00 (주말,공휴일 휴무 / 점심시간 12:00 ~ 13:00)\n';
            } else if (this.goodsType == 'MoneyCoupon' || this.goodsTypesL == 'moneyCoupons') { //모바일금액권
                this.usage.returnsAndRefunds = cancellableDay;
                this.usage.returnsAndRefunds += "\n매장의 귀책(폐업, 품절, 재료소진 등)으로 인하여 서비스 제공이 불가한 경우에는 100%환불 됩니다.";
                this.usage.returnsAndRefunds += "\n남은 잔액은 유효기간 내 사용 가능합니다.";
                this.usage.returnsAndRefunds += "\n유효기간 내 액면가의 60%이상 사용 시, 잔액이 환불 됩니다.";
                this.usage.returnsAndRefunds += "\n단, 환불 금액은 구매하신 할인율에 비례하여 계산됩니다.";
                this.usage.returnsAndRefunds += "\nex) 50,000원 금액권을 45,000원에 구매한 경우, 10,000원이 남으면 9,000원이 환불됩니다.";
                this.usage.returnsAndRefunds += "\n(잔액) - (잔액) x (할인율) = (환불금액) => 10,000 - 10,000 x 10% = 9,000원";
                this.usage.returnsAndRefunds += "\n잔액 환불은 모바일 쿠폰 내 ‘환불신청’을 누르면 신청 가능합니다. ";
                this.usage.returnsAndRefunds += "\n최초 유효기간이 만료된 경우 유효기간 연장을 신청하실 수 있습니다.";
                this.usage.returnsAndRefunds += "\n단, 현재 같은 가격과 구성으로 동일한 상품이 판매되고 있는 경우에만 가능 합니다.";
                this.usage.returnsAndRefunds += '\n"최초 유효기간 이란?" 상품구매 시 최초로 부여되는 유효기간 (연장 이후 기간 제외)';
                this.usage.returnsAndRefunds +=
                    '\n고객센터 문의 (TEL: 1600-3662) - 평일 09:00 ~ 12:00 (주말,공휴일 휴무)' +
                    '\n카카오톡 1:1 채팅 문의 - 평일 09:00 ~ 16:00 (주말,공휴일 휴무 / 점심시간 12:00 ~ 13:00)\n';
            } else if (this.goodsType == 'BookingCoupon' || this.goodsTypesL == 'BookingCoupon') { //예약권
                this.usage.returnsAndRefunds = cancellableDay;
                this.usage.returnsAndRefunds += "\n매장의 귀책(폐업, 품절, 재료소진 등)으로 인하여 서비스 제공이 불가한 경우에는 100%환불 됩니다.";
                this.usage.returnsAndRefunds += "\n최초 유효기간이 만료된 경우 유효기간 연장을 신청하실 수 있습니다.";
                this.usage.returnsAndRefunds += "\n단, 현재 같은 가격과 구성으로 동일한 상품이 판매되고 있는 경우에만 가능 합니다.";
                this.usage.returnsAndRefunds += '\n"최초 유효기간 이란?" 상품구매 시 최초로 부여되는 유효기간 (연장 이후 기간 제외)';
                this.usage.returnsAndRefunds +=
                    '\n고객센터 문의 (TEL: 1600-3662) - 평일 09:00 ~ 12:00 (주말,공휴일 휴무)' +
                    '\n카카오톡 1:1 채팅 문의 - 평일 09:00 ~ 16:00 (주말,공휴일 휴무 / 점심시간 12:00 ~ 13:00)\n';
                this.usage.returnsAndRefunds += "\n▶ 예약 후 취소/환불 안내";
                this.usage.returnsAndRefunds += "\n예약 필수 상품으로 예약 후에는 별도의 취소 규정이 적용됩니다.";
                this.usage.returnsAndRefunds += "\n이용 1일 전 취소 : 100% 환불 됩니다.";
                this.usage.returnsAndRefunds += "\n이용 당일 취소 : 전액 환불 불가 합니다.";
            } else if (this.goodsType == 'Booking') { //예약
                this.usage.returnsAndRefunds = "이용 1일 전 취소 : 100% 환불 됩니다.";
                this.usage.returnsAndRefunds += "\n이용 당일 취소 : 환불 불가 합니다.";
            }else if (this.goodsTypesL == 'pointCoupon' || this.goodsType == 'PointCoupon') { //포인트권
              this.usage.returnsAndRefunds = cancellableDay;
              this.usage.returnsAndRefunds += "\n남은 잔액은 유효기간 내 사용 가능합니다.";
              this.usage.returnsAndRefunds += "\n유효기간 내 액면가의 60%이상 사용 시, 잔액이 환불 됩니다.";
              this.usage.returnsAndRefunds += "\n단, 환불 금액은 구매하신 할인율에 비례하여 계산됩니다.";
              this.usage.returnsAndRefunds += "\nex) 50,000원 금액권을 45,000원에 구매한 경우, 10,000원이 남으면 9,000원이 환불됩니다.";
              this.usage.returnsAndRefunds += "\n(잔액) - (잔액) x (할인율) = (환불금액) => 10,000 - 10,000 x 10% = 9,000원";
              this.usage.returnsAndRefunds += "\n잔액 환불은 모바일쿠폰 내 ‘환불신청’을 누르면 신청 가능합니다.";
              this.usage.returnsAndRefunds += "\n최초 유효기간이 만료된 경우 유효기간 연장을 신청하실 수 있습니다.";
              this.usage.returnsAndRefunds += "\n단, 현재 같은 가격과 구성으로 동일한 상품이 판매되고 있는 경우에만 가능 합니다.";
              this.usage.returnsAndRefunds += "\n\"최초 유효기간 이란?\" 상품구매 시 최초로 부여되는 유효기간 (연장 이후 기간 제외)";
              this.usage.returnsAndRefunds += "\n고객센터 문의 (TEL: 1600-3662) - 평일 09:00 ~ 12:00 (주말,공휴일 휴무)";
              this.usage.returnsAndRefunds += "\n카카오톡 1:1 채팅 문의 - 평일 09:00 ~ 16:00 (주말,공휴일 휴무 / 점심시간 12:00 ~ 13:00)";

            }
        },
        refreshPage() {
            reqGet(
                goodsapi.base,
                goodsapi.goodsinfo + "?goodsId=" + this.goodsId,
                this.authToken,
                (result) => {
                    if (result != null && result.code == rescode.REQ_SUCCESS) {
                        this.goodsType = result.data.goodsType;
                        this.introduction = result.data.introduction;
                        this.getStorebrandinf(result.data.serviceCondition);
                        this.goodsOption = result.data.goodsOption;
                        this.usableHour = result.data.usableHour;
                        // this.b2bChannel = result.data.b2bChannel;
                        this.usage = result.data.usage;
                        if (this.copy === "copy") {

                            console.log(this.goodsOption.options)
                            let newArryGoodsOP = [];
                            // for(let p = 0; p < result.data.goodsOption.options.length; p++){

                            // }
                            newArryGoodsOP = result.data.goodsOption.options;
                            console.log(newArryGoodsOP[0])
                            this.goodsOption.options = [];
                            // console.log(newArryGoodsOP)
                            for (var t = 0; t < newArryGoodsOP.length; t++) {
                                if (this.goodsOption.options.childOptionIds === undefined) {
                                    var noption = {
                                        optionName: newArryGoodsOP[t].optionName, //옵션 이름
                                        mainOption: false, //대표옵션인 경우 true
                                        displayOrder: 1, //표출 순서
                                        listPrice: newArryGoodsOP[t].listPrice, //제품 가격
                                        salePrice: newArryGoodsOP[t].salePrice, //판매 가격
                                        deliveryPrice: newArryGoodsOP[t].deliveryPrice, //입금가. hasOwnDeliveryPrice 가 true 인 경우 필수 입력
                                        inventory: newArryGoodsOP[t].inventory, //판매 수량
                                        ageGroup: newArryGoodsOP[t].ageGroup, //성인, 어린이, 유아 구분(예약/예약권 상품일 경우 입력)[Adult, Child, Baby]
                                        headcount: newArryGoodsOP[t].headcount, //인원수  (예약/예약권 상품일 경우 입력)
                                        currencyCode: newArryGoodsOP[t].currencyCode, //통화 코드  [USD, KRW]
                                        childOptionIds: [],
                                    };
                                    this.goodsOption.options.push(noption);
                                    // alert('childOptionIds')
                                }
                            }
                            for (let p = 0; p < newArryGoodsOP.length; p++) {
                                this.goodsOption.options[p].childOptionIds = newArryGoodsOP[p].childOptions;
                            }

                        }
                        // console.log(result.data.goodsOption.options)
                        if (this.goodsType !== "") {
                            let goodsTyepd1 = false;
                            let goodsTyepd2 = false;
                            if (this.goodsType == "MobileCoupon" || this.goodsType == "BookingCoupon" || this.goodsType == "MoneyCoupon") {
                                goodsTyepd1 = true;
                                goodsTyepd2 = false;
                            } else if (this.goodsType == "Booking") {
                                goodsTyepd1 = false;
                                goodsTyepd2 = false;
                            } else if (this.goodsType == "Combined") {
                                goodsTyepd1 = false;
                                goodsTyepd2 = true;
                            }
                            console.log(goodsTyepd1, goodsTyepd2)
                            this.gotoStep_1(goodsTyepd1, goodsTyepd2);
                        } else {
                            this.gotoStep_1(comTrue, comTrue2);
                        }
                    }
                }
            );
            reqGet(
                goodsapi.base,
                goodsapi.channelsquery + "?goodsId=" + this.goodsId,
                this.authToken,
                (result) => {
                    if (result != null) {
                        if (result.code == rescode.REQ_SUCCESS) {
                            this.b2bChannel = result.data;
                            this.b2bChannel.excludedChannels = [];
                        }
                    }
                }
            );
        },
        getStorebrandinf(svcnt) {
            var storeCodes = [];
            for (var bidx = 0; bidx < svcnt.serviceArea.brands.length; bidx++) {
                storeCodes = storeCodes.concat(svcnt.serviceArea.brands[bidx].storeCodes);
            }
            reqPost(
                brandapi.base,
                brandapi.admofStores,
                this.authToken, {
                    storeCodes: storeCodes,
                },
                (result) => {
                    if (result != null) {
                        if (result.code == rescode.REQ_SUCCESS) {
                            svcnt.serviceArea.brands = result.data.byBrands
                            this.serviceCondition = svcnt;
                        }
                    }
                }
            );
        },
        onMainImage(newval, w, h) {
            this.introduction.mainImage.url = newval; //메인 이미지 url
            this.introduction.mainImage.width = w; //메인 이미지 width
            this.introduction.mainImage.height = h; //메인 이미지 height
        },
        onFakeMainImage(val, w, h) {
            this.fakemainImage.url = val;
            this.fakemainImage.width = w;
            this.fakemainImage.height = h;
        },
        checkStep_3() {
            if(this.goodsType!='PointCoupon'){
                if (this.getTotalStore == 0) {
                  alert("이용 매장을 등록하세요.");
                  return false;
                }
            }else if(this.useStoreToggle ==true && this.getPointCouponTotalStore == 0){
                alert("사용 매장을 등록하세요.");
                return false;
            }


            if (this.serviceCondition.timeCondition.hasSalesPeriod) {
                if (this.serviceCondition.timeCondition.saleStartDate == "" || this.serviceCondition.timeCondition.saleEndDate == "") {
                    alert("판매기간을 선택하세요.");
                    return false;
                }
            }

            if (!this.isBooking(this.goodsType) && !this.comTrue2) {
                if (this.serviceCondition.timeCondition.availableDateSetting == 'SetFromToDate') {
                    if (this.serviceCondition.timeCondition.availableFromDate == "" || this.serviceCondition.timeCondition.availableToDate == "") {
                        alert("유효기간을 선택하세요.");
                        return false;
                    }
                }
            }
            return true;
        },
        usecondition_Next() {
            if (!this.checkStep_3()) {
                return;
            }
            if (this.goodsType != 'Booking') {
                this.gotoStep_4();
            } else {
                this.gotoStep_5();
            }
        },
        baseinfcheck() {
            if (!this.checkStep_1()) {
                return;
            }
            this.gotoStep_2();
        },
        checkStep_2() {
            if (this.goodsOption.options.length == 0) {
                alert("옵션을 추가하세요.");
                chval = this.goodsOption.options.filter((eitem) => eitem.headcount == "" || eitem.headcount == null);
                if (chval.length > 0) {
                    alert("인원수를 입력하세요.");
                    return false;
                }
                return false;
            }
            if (!this.isMobile(this.goodsType) && this.usableHour.dayOfWeekType == 'Custom') {
                if (!this.usableHour.monday && !this.usableHour.tuesday && !this.usableHour.wednesday && !this.usableHour.thursday && !this.usableHour.friday && !this.usableHour.saturday && !this.usableHour.sunday) {
                    alert("적용요일을 선택하세요.");
                    return false;
                }
            }
            if (this.goodsType !== 'Combined') {
                if (!this.isMobile(this.goodsType) && this.usableHour.hours.length == 0) {
                    alert("적용 시간을 추가하세요.");
                    return false;
                }
                if (!this.isMobile(this.goodsType)) {
                    var chval = this.goodsOption.options.filter((eitem) => eitem.ageGroup == null);
                    if (chval.length > 0) {
                        alert("권종을 입력하세요.");
                        return false;
                    }
                }

            }
            return true;
        },
        checkOptionPrice() {
            if (!this.checkStep_2()) {
                return;
            }
            this.gotoStep_3();
        },
        inputableDayCount() {
            if (this.serviceCondition.timeCondition.availableDayCount < 1) {
                this.serviceCondition.timeCondition.availableDayCount = 1;
            }
        },
    },
};
</script>

<style scoped>
/* 2022 - 01 -03 추가 */

.addimgInputGroup.wid100 {
    width: 100%;
}

.flexDiv {
    display: flex;
    justify-content: space-between;
}

.modal-body.addmodals {
    display: flex;
    justify-content: space-between;
}

.modal-body.addmodals .imgBoxDivGroup {
    width: 50%;
}

.addimgInputGroup {
    width: 45%;
    vertical-align: top;
}

.modal-body.addmodals .imgBoxDivGroup .imgDragbox {
    width: 100%;
}

.mr-05 {
    margin-right: 5px;
}

/* 2022 - 01 -03 추가 끝 */
.radio>label {
    margin-right: 10px;
}

ul.tab li {
    list-style: none;
    display: inline-block;
    border-bottom: 1px solid #337ab7;
    margin-left: 15px;
    color: #337ab7;
    cursor: pointer;
}

ul.tab li:hover {
    font-weight: 600;
}

ul.tab {
    padding: 0;
    text-align: left;
    margin-left: 13px;
    margin-bottom: 20px;
    margin-top: 5px;
}

ul.tab li:first-child {
    margin-left: 0;
}

.imgdragselect {
    width: auto;
    margin-left: 14px;
    margin-bottom: 10px;
    display: inline-block;
    vertical-align: top;
    margin-right: 10px;
}

.imgDragbox-div {
    text-align: left;
}

.mt-2 {
    margin-top: 20px;
}

.checkbox>label {
    margin-right: 10px;
}

.step {
    flex: 1;
    display: block;
    text-align: center;
    position: relative;
}

.passline {
    position: relative;
}

.displayIn>div {
    display: inline-block;
    vertical-align: top;
}

.left-store-btn {
    margin-left: 10px;
}

.point_pass {
    position: absolute;
    top: 0px;
    left: calc(50% - 10px);
    border-radius: 100px;
    width: 20px;
    height: 20px;
    border: 2px solid #00a7d0;
    margin: auto;
    background-color: #00a7d0;
}

.point_fail {
    position: absolute;
    top: 0px;
    left: calc(50% - 10px);
    border-radius: 100px;
    width: 20px;
    height: 20px;
    border: 2px solid #00a7d0;
    margin: auto;
    background-color: #fff;
}

.leftline {
    width: 50%;
    height: 2px;
    position: absolute;
    left: 0px;
    top: 10px;
}

.rightline {
    width: 50%;
    height: 2px;
    position: absolute;
    right: 0px;
    top: 10px;
}

.bgpass {
    background-color: #00a7d0;
}

.bgfail {
    background-color: #d2d6de;
}

.modal {
    background-color: #00000047;
    overflow: scroll;
}

.modal-footer {
    text-align: center;
}

.modal-dialog.drag {
    width: 70%;
    margin: 30px auto;
}

ul.titleArr {
    margin: 0;
    text-align: left;
    padding: 0;
    margin-left: 14px;
}

ul.titleArr li {
    list-style: none;
    display: inline-block;
    margin-left: 10px;
    cursor: pointer;
}

ul.titleArr li:first-child {
    margin: 0;
}

.imgBoxDivGroup {
    display: flex;
    width: 100%;
    justify-content: center;
}

.imgboxChild:nth-child(1n) {
    margin-right: 10px;
}

.imgBoxDivGroup>div .imgboxChild {
    height: 200px;
    width: 200px;
    margin-bottom: 10px;
    display: inline-block;
    object-fit: contain;
    background: #f5f5f5;
    padding: 12px;
}

.imgDragbox {
    text-align: center;
    padding: 20px;
    margin-left: 20px;
    width: 50%;
}

.btn-app h3 {
    font-weight: bold !important;
    color: #000000;
}

.btn-app {
    height: auto !important;
    padding: 25px 0px;
    width: 200px;
}

.btn-app p {
    font-size: 14px;
    font-weight: 600;
    color: #000000;
}

.btn-selweek {
    background-color: #5B9BD5;
    color: #FFFFFF;
}

@media (min-width: 768px) {
    .mtitle {
        margin-top: 150px;
        margin-bottom: 50px;
    }

    .weeksel {
        margin-left: 30px;
    }

    .pgheader {
        margin-bottom: 10px;
    }

    .linebg {
        width: 100%;
        height: 20px;
    }

    .addlist {
        display: inline-flex;
    }
}

@media (max-width: 768px) {
    .weeksel {
        margin-top: 10px;
    }

    .pgheader {
        margin-bottom: 30px;
    }

    .linebg {
        width: 100%;
        height: 20px;
    }

    .ptlbl {
        position: absolute;
        top: 20px;
        left: -50%;
        width: 200%;
    }

    .pttop {
        position: absolute;
        bottom: 20px;
        left: -50%;
        width: 200%;
    }

    .addlist .thumbnail {
        margin-bottom: 10px;
    }
}

.input-group.checkbox.nosoi {
    display: none !important;
}

.dropbox>.imgboxChild,
.dropboxMain>.imgboxChild {
    display: none !important;
}
</style>
